import * as React from "react";
import shortid from "shortid";
import cloneDeep from "lodash/cloneDeep";
import { Modal, styled, Tooltip } from "@lib/components";
import { ModalContent } from "@lib/components";
import { Button } from "@lib/components";
import { RotateLoader } from "@lib/components";
import { DragDropContext, DropResult } from "react-beautiful-dnd";
import { arrayMove } from "react-sortable-hoc";
import { CoreUtils, getId, logger, normalizeObject, RestaurantUtils, Untrusive } from "@lib/common";
import { inject, observer } from "mobx-react";
import { MobxComponent } from "../../../../../mobx/components";
import { Tag } from "@lib/components";
import { Checkbox } from "@lib/components";

import { getNextDayOpenTime, isDishPaused } from "../orders/sidebars/pauseServicesSidebar/constants";
import { FaFlushed } from "react-icons/fa"
import { UI } from "../../../../../core/ui";
import { ResumeModal } from "../menus/components/ResumeModal";
import { MENU_ITEM_TYPE, MENU_COMPONENTS } from "../menus/constant";
import { RestaurantFormCategory } from "../menus/forms/category";
import { RestaurantFormDish } from "../menus/forms/dish";
import { RestaurantFormMenu } from "../menus/forms/menu";
import { MenuListButton } from "../menus/layout/button";
import { MenuItemText, MenuListFloatingButtonWrapper, MenuListFloatingContent, MenuListFloatingTitle } from "../menus/layout/floating-button";
import { MenuListItem } from "../menus/layout/item";
import { MenuList } from "../menus/layout/list";
import { PauseSidebar } from "../menus/pauseItemsSidebar";
import { ItemButton, MenuListItemV2 } from "./item-v2";
import { RestaurantFormMenuV2 } from "./menu_v2";
import { TabGroup, TabItem } from "../settings-v2/receipt-printing";
import { RestaurantFormCategoryV2 } from "./category_v2";
import { RestaurantFormDishV2 } from "./dish-v2";
import { BottomMenuControls, CopyIcon, DeleteIcon, EditIcon } from "../menus/mobileView/menuList/bottomMenuControls";
import { MenuCardTitle, MenuItemColor, TextEllipsis } from ".";
import { MenuColor } from "../../../../components/v2/menucolor";
import { MenuVisibility } from "../../../../components/v2/menuvisibility";
import { MenuPreVisibility } from "../../../../components/v2/menuprevisibility";
import { MenuMoreAction } from "../../../../components/v2/menumoreaction";
import { MenuFilterMenu } from "../../../../components/v2/menufiltermenu";
import { MenuPrinterSettings } from "../../../../components/v2/menuprintersettings";
import { MenuPrinterEligibleItems } from "../../../../components/v2/menuprintereligibleitems";
import { MenuPrinterAssignItems } from "../../../../components/v2/menuprinterassignitem";
import { MenuPreOverride, type OverrideTargetEntity, type OverrideChangesSummary, type OverrideEditKind, type AffectedEntityRow, getServicesFromAvailability, getServiceLabels, formatPosPrinterValuesForDisplay } from "../../../../components/v2/menupreoverride";
import { ButtonV2, EditingStatusAlertModal, EditingStatusAlertModalBody, EditingStatusAlertModalContent, EditingStatusAlertModalHeader, EditingStatusAlertModalHeaderText, EditingStatusIconWrapper, MenuActionContainer, MenuActionItem, MenuStatusAlert } from "../../../../components/v2/layout.c";
import { IconArrowForward, IconArrowForwardWhite, IconCopyAlt, IconDelete, IconEdit, IconEditingClose } from "../../../../components/v2/icons";
import { isObject } from "lodash";
import uuid from "uuid";
import { toJS } from "mobx";
import { PauseIcon } from "../orders-v2/board-v2-icon";
import { IoIosPause } from "react-icons/io";
export type MenuComponents = "menu" | "category" | "item";

interface RestaurantDishWithTaxes
	extends T.Schema.Restaurant.Menu.RestaurantDish { }

type MenusEditMode = "normal" | "reOrder" | "editPrices";

type MenuPendingOverride = {
	kind: 'visibility' | 'color';
	targetEntityType: 'menu' | 'category' | 'item';
	menuIndex: number;
	menuId: string;
	categoryId?: string;
	parentAvailabilityId: string;
	parentMergedAvailability: any;
	newColor?: string;
	newMediaUrl?: string;
};

const EditPricesModeWrapper = styled("div")`

	display: flex;
	flex-direction: column-reverse;
	align-items: center;
	justify-content: center;
	gap: 16px;
	background: white;
	position: fixed;
	width: 100%;
	left: 0px;
	right: 0px;
	padding: 0px 16px 16px;
	bottom: 0px;

	& .grid-2 {
		width: 100%;
		& .col {
			width: 100%;
			& button {
				width: 100%;
			}
		}
	}
	p {
		color: #fb2f2f;
	}

	@media (min-width: 768px) {
		& .grid-2 {
			width: 25%;
		}
	}

`;

interface Props { }
interface State {
	panel: MenuComponents | null;
	panel_index: number[];
	panel_pause: MenuComponents | null;
	panel_index_pause: number[];
	copy_type: MenuComponents | null;
	copy_index: number[];
	copy_loading: boolean;
	remove_type: MenuComponents | null;
	remove_index: number[];
	remove_loading: boolean;
	mode: MenusEditMode;
	loading: boolean;
	selected_dishes: string[];
	selected_loading: boolean;
	error: string | null;
	currentMenuItemId: string;
	currentMenuItem: T.Schema.Restaurant.Menu.RestaurantDish | T.Schema.Restaurant.Menu.RestaurantItem | null;
	currentMenuItems: T.Schema.Restaurant.Menu.RestaurantDish[] | T.Schema.Restaurant.Menu.RestaurantItem[];
	resumeModalOpen: boolean;
	oneTimeRenderFlag: boolean;
	activeDeleteItemModal: boolean;
	activeMobile: string | null;
	showBottomControl: string | null;
	activeMenuColorModal: boolean;
	activeMenuColorTitle?: string;
	activeMenuColorData: {
		color?: string;
		media_url?: string,
		title?: string
	}
	targetItem: string;
	targetIndex: number;
	targetMenuIndex: number;
	targetCategoryIndex: number;
	activeMenuVisibilityModal: boolean;
	activeMenuPrevisibilityModal: boolean;
	/** Item ids to apply item color to on save (snapshot when opening color from a selected row). */
	menuColorBulkItemIds: string[] | null;
	/** When user clicks a printer in Printer Setup, we open Eligible Items with this name */
	selectedPrinterForEligible: { name: string; _id: string } | null;
	/** When opening Assign Printers from an item row, we pass this target so we can load/save item printers */
	printerAssignTarget: { menuIndex: number; categoryIndex: number; itemId: string; menuId: string; categoryId: string } | null;
	/** When set, printer assign save applies the same printers to all these item ids (bulk from selection sheet). */
	printerAssignBulkItemIds: string[] | null;
	/** User closed the v2 bulk selection sheet while items remain selected; reopen when selection goes 0 → 1+. */
	bulkSelectedDishesSheetDismissed: boolean;
	/** Context for override warning/confirm modals: which entity and what will change */
	preOverrideContext: {
		targetEntity: OverrideTargetEntity;
		changesSummary?: OverrideChangesSummary | null;
		overrideSource?: { menuId: string; categoryId?: string; itemId?: string };
		editKind?: OverrideEditKind;
		affectedEntities?: AffectedEntityRow[];
		pendingOverride?: MenuPendingOverride | null;
	} | null;
}

function getAvailFromMenuById(menu: any, id: string | undefined) {
	if (!id) return null;
	return menu.availabilities?.find((a: any) => a.id === id) ?? null;
}

function hasDisplayColor(ent: any) {
	return typeof ent?.color === 'string' && ent.color.trim().length > 0;
}

function hasPosColor(ent: any) {
	const c = ent?.integrations?.pushpos?.color;
	return typeof c === 'string' && c.trim().length > 0;
}

function hasPosPrinterList(ent: any) {
	const p = ent?.integrations?.pushpos?.printers;
	return Array.isArray(p) && p.length > 0;
}

function categoryHasOwnAvailability(menu: any, cat: any) {
	return !!(cat?.availability_id && cat.availability_id !== menu.availability_id);
}

function itemHasOwnAvailability(menu: any, cat: any, item: any) {
	const parentId = cat?.availability_id || menu.availability_id;
	return !!(item?.availability_id && item.availability_id !== parentId);
}

function analyzeDescendantsOverride(args: {
	menu: any;
	targetType: 'menu' | 'category' | 'item';
	categoryId?: string;
	editKind: OverrideEditKind;
	preMergeAvailById: Map<string, any>;
	mergedParentAvailability: any;
	mergedParentAvailabilityId: string;
	newColor?: string;
	newMediaUrl?: string;
}): { affectedRows: AffectedEntityRow[]; changesSummary: OverrideChangesSummary | null } {
	const {
		menu,
		targetType,
		categoryId,
		editKind,
		preMergeAvailById,
		mergedParentAvailability,
		mergedParentAvailabilityId,
		newColor,
	} = args;
	const affectedRows: AffectedEntityRow[] = [];
	const toServiceLabels = getServiceLabels(getServicesFromAvailability(mergedParentAvailability));

	const buildRow = (
		entityType: 'category' | 'item',
		ent: any,
		cat: any | null,
		resolvedAvailId: string | undefined
	): AffectedEntityRow | null => {
		const custom =
			hasDisplayColor(ent) ||
			hasPosColor(ent) ||
			hasPosPrinterList(ent) ||
			(entityType === 'category'
				? categoryHasOwnAvailability(menu, ent)
				: itemHasOwnAvailability(menu, cat!, ent));
		if (!custom) return null;

		const fromAvail =
			(resolvedAvailId && preMergeAvailById.get(resolvedAvailId)) ||
			getAvailFromMenuById(menu, resolvedAvailId);
		const fromServiceLabels = getServiceLabels(getServicesFromAvailability(fromAvail));

		const row: AffectedEntityRow = {
			entityType,
			name: ent.name ?? '—',
			id: ent.id,
		};

		if (editKind === 'color' && newColor != null) {
			if (hasDisplayColor(ent)) row.displayColor = { from: ent.color, to: newColor };
			if (hasPosColor(ent)) {
				row.posColor = { from: ent.integrations.pushpos.color, to: '—' };
			}
			if (hasPosPrinterList(ent)) {
				const fromLabs = formatPosPrinterValuesForDisplay(ent.integrations.pushpos.printers);
				row.posPrinters = { from: fromLabs, to: fromLabs };
			}
			if (
				entityType === 'category'
					? categoryHasOwnAvailability(menu, ent)
					: itemHasOwnAvailability(menu, cat!, ent)
			) {
				row.serviceTypes = { from: fromServiceLabels, to: fromServiceLabels };
			}
		} else {
			const willChangeAvail =
				entityType === 'category'
					? categoryHasOwnAvailability(menu, ent)
					: itemHasOwnAvailability(menu, cat!, ent);
			if (willChangeAvail) {
				row.serviceTypes = { from: fromServiceLabels, to: toServiceLabels };
			}
			if (hasDisplayColor(ent)) row.displayColor = { from: ent.color, to: '—' };
			if (hasPosColor(ent)) row.posColor = { from: ent.integrations.pushpos.color, to: '—' };
			if (hasPosPrinterList(ent)) {
				const fromLabs = formatPosPrinterValuesForDisplay(ent.integrations.pushpos.printers);
				row.posPrinters = { from: fromLabs, to: fromLabs };
			}
		}

		return row;
	};

	if (targetType === 'menu') {
		for (const cat of menu.categories ?? []) {
			const resolved = cat.availability_id || menu.availability_id;
			const row = buildRow('category', cat, null, resolved);
			if (row) affectedRows.push(row);
		}
		for (const item of menu.items ?? []) {
			const cat = menu.categories?.find((c: any) => c.id === item.category_id);
			if (!cat) continue;
			const resolved = item.availability_id || cat.availability_id || menu.availability_id;
			const row = buildRow('item', item, cat, resolved);
			if (row) affectedRows.push(row);
		}
	} else if (targetType === 'category' && categoryId) {
		const cat = menu.categories?.find((c: any) => c.id === categoryId);
		if (!cat) return { affectedRows: [], changesSummary: null };
		for (const item of (menu.items ?? []).filter((i: any) => i.category_id === categoryId)) {
			const resolved = item.availability_id || cat.availability_id || menu.availability_id;
			const row = buildRow('item', item, cat, resolved);
			if (row) affectedRows.push(row);
		}
	}

	let changesSummary: OverrideChangesSummary | null = null;
	if (editKind === 'visibility') {
		const menuFromAvail =
			preMergeAvailById.get(mergedParentAvailabilityId) || mergedParentAvailability;
		const fromLabs = getServiceLabels(getServicesFromAvailability(menuFromAvail));
		changesSummary = { serviceTypes: { from: fromLabs, to: toServiceLabels } };
	} else if (editKind === 'color' && newColor != null) {
		changesSummary = { displayColor: { to: newColor } };
	}

	return { affectedRows, changesSummary };
}

function findItemInMenusV2(
	menus: any[],
	itemId: string
): { menuIndex: number; categoryId: string; item: any; globalIdx: number } | null {
	for (let menuIndex = 0; menuIndex < menus.length; menuIndex++) {
		const menu = menus[menuIndex];
		const items = menu.items || [];
		for (let globalIdx = 0; globalIdx < items.length; globalIdx++) {
			const it = items[globalIdx];
			if (it.id !== itemId) continue;
			const cat = menu.categories?.find((c: any) => c.id === it.category_id);
			if (!cat) return null;
			return { menuIndex, categoryId: cat.id, item: it, globalIdx };
		}
	}
	return null;
}

@inject("store")
@observer
export class RestaurantMenuListV2 extends MobxComponent<Props, State> {
	menu_backup: T.Schema.Restaurant.RestaurantSchema["menus"] | null;
	menu_backup_v2: T.Schema.Restaurant.RestaurantSchema["menus_v2"] | null = null;
	interval: number | null = null;
	_menuEditCollaborationActive = false;

	constructor(props: Props) {
		super(props);
		this.state = {
			panel: null,
			panel_index: [],
			copy_type: null,
			copy_index: [],
			copy_loading: false,
			remove_type: null,
			remove_index: [],
			remove_loading: false,
			mode: "normal",
			loading: false,
			selected_dishes: [],
			selected_loading: false,
			error: null,
			activeDeleteItemModal: false,
			panel_pause: null,
			panel_index_pause: [],
			currentMenuItemId: "",
			currentMenuItem: null,
			currentMenuItems: [],
			resumeModalOpen: false,
			oneTimeRenderFlag: true,
			activeMobile: '',
			showBottomControl: '',
			activeMenuColorModal: false,
			activeMenuColorTitle: '',
			activeMenuColorData: {
				color: '',
				media_url: '',
				title: ''
			},
			targetIndex: -1,
			targetCategoryIndex: -1,
			targetMenuIndex: -1,
			targetItem: 'menu',
			activeMenuVisibilityModal: false,
			activeMenuPrevisibilityModal: false,
			menuColorBulkItemIds: null,
			selectedPrinterForEligible: null,
			printerAssignTarget: null,
			printerAssignBulkItemIds: null,
			bulkSelectedDishesSheetDismissed: false,
			preOverrideContext: null,
	};
		this.menu_backup = null;
		this.interval = null;
	}

	_maybeStartOrStopMenuEditTracking() {
		const { store } = this.injected;
		const want =
			store.organisation?.dashboard === 'v2.1' &&
			store.isNewMenuSchema;
		if (want && !this._menuEditCollaborationActive) {
			this._menuEditCollaborationActive = true;
			store.notifications.menuEditingMenusMounted();
		} else if (!want && this._menuEditCollaborationActive) {
			store.notifications.menuEditingMenusUnmounted();
			this._menuEditCollaborationActive = false;
		}
	}

	async componentDidMount(): Promise<void> {
		const { store } = this.injected;
		if(store.isNewMenuSchema) {
			const restaurant = store.restaurant!;
			this.setState({
				loading: true
			});
			const get_menus = await store.api.menu_get_menus(restaurant._id!);
			store.updateRestaurant({
				menus_v2: store.isNewMenuSchema ? get_menus.menus : [], //v2.0
				menus: !store.isNewMenuSchema ? get_menus.menus: [], //v1.0
				option_sets_v2: store.isNewMenuSchema ? get_menus.modifiers : [], //v2.0
				option_sets: !store.isNewMenuSchema ? get_menus.option_sets: [], //v1.0
			});
			this.setState({
				loading: false
			});
		}

		this._maybeStartOrStopMenuEditTracking();
	}

	componentDidUpdate() {
		this._maybeStartOrStopMenuEditTracking();
	}

	applyPendingMenuOverride = async () => {
		const ctx = this.state.preOverrideContext;
		const pending = ctx?.pendingOverride;
		const store = this.injected.store;
		const r = store.restaurant;
		if (!pending || !r?._id) return;

		const menus = cloneDeep(r.menus_v2 || []);
		const menu = menus[pending.menuIndex];
		if (!menu || menu.id !== pending.menuId) return;

		try {
			if (pending.kind === 'visibility') {
				const merged = pending.parentMergedAvailability;
				const aid = pending.parentAvailabilityId;
				if (pending.targetEntityType === 'menu') {
					for (const cat of menu.categories ?? []) {
						if (categoryHasOwnAvailability(menu, cat)) {
							await store.api.menu_partial_update_category({
								restaurant_id: r._id,
								menu_id: menu.id,
								category_id: cat.id,
								data: { availability: { ...merged }, availability_id: aid },
							});
							cat.availability_id = aid;
						}
					}
					for (const item of menu.items ?? []) {
						const cat = menu.categories?.find((c: any) => c.id === item.category_id);
						if (!cat) continue;
						if (itemHasOwnAvailability(menu, cat, item)) {
							await store.api.menu_partial_update_item({
								restaurant_id: r._id,
								menu_id: menu.id,
								category_id: cat.id,
								item_id: item.id,
								data: { availability: { ...merged }, availability_id: aid },
							});
							item.availability_id = aid;
						}
					}
				} else if (pending.targetEntityType === 'category' && pending.categoryId) {
					const cat = menu.categories?.find((c: any) => c.id === pending.categoryId);
					if (!cat) return;
					for (const item of (menu.items ?? []).filter((i: any) => i.category_id === pending.categoryId)) {
						if (itemHasOwnAvailability(menu, cat, item)) {
							await store.api.menu_partial_update_item({
								restaurant_id: r._id,
								menu_id: menu.id,
								category_id: cat.id,
								item_id: item.id,
								data: { availability: { ...merged }, availability_id: aid },
							});
							item.availability_id = aid;
						}
					}
				}
			} else if (pending.kind === 'color' && pending.newColor != null) {
        const categoriesToUpdate: any = []
        const itemsToUpdate: any = []
				for (const row of ctx?.affectedEntities ?? []) {
					if (row.entityType === 'category') {
						categoriesToUpdate.push(store.api.menu_partial_update_category({
							restaurant_id: r._id,
							menu_id: menu.id,
							category_id: row.id,
							data: { color: pending.newColor, media_url: pending.newMediaUrl ?? '' },
						}));
						const c = menu.categories?.find((x: any) => x.id === row.id);
						if (c) {
							c.color = pending.newColor;
							c.media_url = pending.newMediaUrl ?? '';
						}
					} else {
						const item = menu.items?.find((x: any) => x.id === row.id);
						const cat = menu.categories?.find((c: any) => c.id === item?.category_id);
						if (!item || !cat) continue;
            itemsToUpdate.push({
              menu_id: menu.id,
              category_id: cat.id,
              id: item.id,
              color: pending.newColor,
              media_url: pending.newMediaUrl ?? ''
            })
						item.color = pending.newColor;
						item.media_url = pending.newMediaUrl ?? '';
					}
				}
        if (categoriesToUpdate.length > 0) {
          await Promise.all(categoriesToUpdate);
        }
        if (itemsToUpdate.length > 0) {
          await store.api.menu_partial_update_batch_items({
            restaurant_id: r._id,
            data: {items: itemsToUpdate}
          });
        }
			}
			await store.updateRestaurant({ menus_v2: menus });
			UI.notification.success(
				pending.kind === 'visibility' ? 'Visibility applied to descendants' : 'Colors applied to descendants'
			);
		} catch (e) {
			UI.notification.error((e as any)?.message ?? 'Failed to apply overrides');
		}
	};


	componentWillUnmount() {
		if (this._menuEditCollaborationActive) {
			this.injected.store.notifications.menuEditingMenusUnmounted();
			this._menuEditCollaborationActive = false;
		}
		if (this.state.mode !== "normal") {
			this.cancelEditMode();
		}
		if (this.interval) {
			clearInterval(this.interval);
		}
	}


	setPanel = (panel: MenuComponents | null, panel_index: number[]) => {
		this.setState({ panel, panel_index });
	};

	setOnPause = (panel: MenuComponents | null, panel_index: number[], id: string, item: T.Schema.Restaurant.Menu.RestaurantDish | T.Schema.Restaurant.Menu.RestaurantItem | null, items: T.Schema.Restaurant.Menu.RestaurantDish[] | T.Schema.Restaurant.Menu.RestaurantItem[]) => {
		this.setState({ panel_pause: panel, panel_index_pause: panel_index, currentMenuItemId: id, currentMenuItem: item, currentMenuItems: items });
	};

	create_menu = (): T.Schema.Restaurant.Menu.RestaurantMenu => {
		const _id = shortid.generate();
		return {
			_id,
			name: "",
			display_name: "",
			description: "",
			conditions: {
				hide_unavailable_menu: false,
				services: [],
				times: [],
				hours: [],
				pre_order: {
					enabled: false,
					days_in_advance: "",
					cutoff_time: "",
				},
				age_restricted: false,
			},
			categories: [],
			//@ts-ignore
			kounta: {
				kounta_sync_export_enabled: false,
				// kounta_username: "",
				// kounta_password: "",
				// kounta_site: ""
			},
		};
	};
	create_menu_v2 = (): T.Schema.Restaurant.Menu.RestaurantMenuV2 => {
		const { store } = this.injected;
		const restaurant = store.restaurant!;
		const id = shortid.generate();

		return {
			id,
			name: "",
			items: [],
			categories: [],
			restaurant_id: restaurant._id,
			availability_id: "",
			availabilities: []
		};
	};
	create_category(
		menu_id: string
	): T.Schema.Restaurant.Menu.RestaurantCategory {
		return {
			_id: shortid.generate(),
			menu_id,
			name: "",
			display_name: "",
			description: "",
			dishes: [],
			conditions: {
				hide_unavailable_category: false,
				services: [],
				hours: [],
			},
		};
	}
	create_dish(menu_id: string, category_id: string): RestaurantDishWithTaxes {
		const r = this.injected.store.restaurant!;
		const taxRates = r.settings.region.tax.rates ?? []
		const taxes = taxRates.map((rate: any) => getId(rate));
		return {
			type: "standard",
			_id: shortid.generate(),
			menu_id: menu_id,
			category_id: category_id,
			name: "",
			display_name: "",
			description: "",
			subtitle: "",
			price: "" as any,
			tags: [],
			image: null,
			status: null,
			// STANDARD
			ingredients: [],
			option_sets: [],
			// COMBO
			choices: [],
			price_type: "standard",
			taxes: taxes,
		};
	}

	generateCreateMenuButton = () => {
		const { store } = this.injected;
		return (
			<TabItem
				key="btn-create"
				onClick={() => store.setActiveMobileMenu('create-menu', 'menus', {panel: 'menu', index: -1})}
				className="footer-button"
				style={{ height: '42px' }}
			>
				Create Menu
			</TabItem>
		);
	}

	list_menu = () => {
		const { store } = this.injected;
		const { activeMobileMenu } = store;
		const {
			loading: loading,
			mode,
			activeMenuColorModal,
			targetIndex,
			targetItem,
			activeMenuVisibilityModal,
			activeMenuPrevisibilityModal,
		} = this.state;
		const r = this.injected.store.restaurant!;
		const { menus } = r;
		const { pausedMenuItems,
			openMenuListItemActive,
			openMenuBottomMenuControl,
			setOpenMenuBottomMenuControl,
			setOpenMenuListItemActive } = this.injected.store;

		const menuIds = pausedMenuItems.map(dish => dish?.menu_id);

		return (
			<>
				{(activeMobileMenu.name !== 'create-menu'
				&& activeMobileMenu.name !== 'edit-menu'
				&& activeMobileMenu.name !== 'create-category'
				 && activeMobileMenu.name !== 'edit-category'
				 && activeMobileMenu.name !== 'create-item'
				 && activeMobileMenu.name !== 'edit-item') && (
					<>

					<MenuList id="menu-list" type={MENU_ITEM_TYPE.MENU}>
					{r.menus.map((menu: T.Schema.Restaurant.Menu.RestaurantMenu, i: number) => {
						const totalItems = menu.categories.map((item: any) => item.dishes).flat().length
						return (

							<MenuListItemV2
								key={menu._id || 'menu-'+i}
								type={MENU_ITEM_TYPE.MENU}
								id={menu._id || 'menu-'+i}
								mode={mode}
								onClick={() => {
									const isAlreadyOpen = openMenuListItemActive === menu._id || (openMenuListItemActive && openMenuListItemActive.startsWith(menu._id + '_'));
									if (isAlreadyOpen) {
										setOpenMenuListItemActive('');
									} else {
										setOpenMenuListItemActive(menu._id);
									}
								}}
								onMoreAction={this.openMenuMoreActions}
								active={openMenuListItemActive || ''}
								activeVisibility={activeMenuPrevisibilityModal}
								toggleActiveVisibility={() => this.setState({
									activeMenuPrevisibilityModal: !activeMenuPrevisibilityModal
								})}
								toggleActiveMobileModal={() => {
									this.injected.store.setActiveMobileModal('desktop-printer-settings')}
								}
								isMenu
								name={
									<div className="flex-line centered" style={{gap: 8}}>
										<TextEllipsis>{isObject(menu.name) ? JSON.stringify(menu.name): menu.name}</TextEllipsis>
									</div>
								}
								index={i}
								onEdit={() => { store.setActiveMobileMenu('edit-menu', 'menus', {panel: 'menu', index: i});}}
								onRemove={() =>
									this.modal_remove_open("menu", [i])
								}
								onCopy={() => this.modal_copy_open("menu", [i])}
								isPausing={menuIds.includes(menu._id)}
								totalItems={totalItems}
								totalPausedItems={pausedMenuItems.filter(pausedItem => pausedItem?.menu_id === menu._id).length}
							>
								{this.list_category(i)}
							</MenuListItemV2>
						);
					})}
					</MenuList>
					{mode === "normal" && (
						<>
							{menus.length > 0 ? (
								<TabGroup className='menus menus-end menus-header' style={{ overflow: 'unset', marginTop: 10}}>
									{this.generateCreateMenuButton()}

										<TabItem
											key="btn-re-arrange"
											onClick={() =>
												this.startEditMode("reOrder")
											}
											className="footer-button"
											style={{ height: '42px'}}
										>
											Re-Arrange
										</TabItem>

										<TabItem
											key="btn-edit-prices"
											onClick={() =>
												this.startEditMode("editPrices")
											}
											className="footer-button"
											style={{ height: '42px'}}
										>
											Edit Prices
										</TabItem>
								</TabGroup>
							) : (
								this.generateCreateMenuButton()
							)}
						</>
					)}

					{mode === "reOrder" &&
						this.saveCancelGroupButton(
							() =>
								this.saveEditMode("Menu Re-arranged Successfully!"),
							this.cancelEditMode,
							loading,
							"Re-Arrange Mode\n\nClick + hold to drag and drop items to re-order them"
						)}

					{mode === "editPrices" &&
						this.saveCancelGroupButtonV2(
							() => this.saveEditMode("Prices Updated Successfully!"),
							this.cancelEditMode,
							loading,
						"Bulk Edit Prices Mode"
					)}
					</>)}
			</>
		);
	};
	list_category = (menuIndex: number) => {
		const { mode, activeMenuColorModal, targetIndex, targetItem } = this.state;
		const r = this.injected.store.restaurant!;
		const menu = r.menus[menuIndex];
		const { pausedMenuItems, openMenuListItemActive, setOpenMenuListItemActive  } = this.injected.store;
		const pauseIds = pausedMenuItems.map(d => d?._id);
		const { store } = this.injected;
		const { activeMobileMenu } = store;

		const checkCateIsPausing = (category: T.Schema.Restaurant.Menu.RestaurantCategory) => {
			if (category && category.dishes && category.dishes.length) {
				return category.dishes.map(cate => cate._id).filter(d => pauseIds.includes(d)).length
			}
		};

		return (
			<>
			{(activeMobileMenu.name !== 'create-category' && activeMobileMenu.name !== 'edit-category') && (
			<MenuList id={menu._id || 'menu-'+menuIndex} type={MENU_ITEM_TYPE.CATEGORY}>
				{menu.categories.map((category:  T.Schema.Restaurant.Menu.RestaurantCategory, i: number) => {
					const totalItems = (category.dishes || []).filter((cate: any) => normalizeObject(cate).id).length;
					const isAbacusOpenItemsAvailable =
						!!r.abacus?.abacus_status &&
						!!r.abacus?.abacus_open_items;

					const noAbacusOpenItem =
						isAbacusOpenItemsAvailable && !category.abacus_open_item
							? "No Abacus Open Item"
							: "";
					return (
						<MenuListItemV2
							key={category._id || 'category-'+i}
							id={category._id || 'category-'+i}
							type={MENU_ITEM_TYPE.CATEGORY}
							onClick={() => {
								if(this.state.activeMobile === category._id) {
									this.setState({ activeMobile: '' });
								} else {
									this.setState({ activeMobile: category._id });
								}
							}}
							active={this.state.activeMobile || ''}
							onMoreAction={() => this.openCategoryMoreActions(i, menuIndex, 'category')}
							mode={mode}
							isMenu
							name={
								<div className="flex-l-r-center width100">
									<div className="flex-line centered" style={{gap: 8}}>
										<MenuCardTitle>
											<TextEllipsis>{isObject(category.name) ? JSON.stringify(category.name): category.name}</TextEllipsis>
										</MenuCardTitle>
									</div>

									{noAbacusOpenItem &&
										<Tooltip text="Please edit this category and set the Abacus Open Item" width={360} position="top">
											<Tag className="m-r-2">{noAbacusOpenItem}</Tag>
										</Tooltip>
									}
								</div>
							}
							index={i}
							onEdit={() =>
								{ this.setPanel("category", [menuIndex, i]);  store.setActiveMobileMenu('edit-category', 'menus', {panel: 'category', menuIndex: menuIndex, categoryIndex: i});}
							}
							onRemove={() =>
								this.modal_remove_open("category", [
									menuIndex,
									i,
								])
							}
							onCopy={() =>
								this.modal_copy_open("category", [menuIndex, i])
							}
							isPausing={!!checkCateIsPausing(category)}
							totalItems={totalItems}
							totalPausedItems={checkCateIsPausing(category)}
						>
							{this.list_dish(menuIndex, i)}
						</MenuListItemV2>
					);
				})}
				{mode === "normal" && (
					<TabGroup className='menus menus-end menus-header' style={{ overflow: 'unset', justifyContent: 'end'}}>
						<TabItem
						onClick={() => store.setActiveMobileMenu('create-category', 'menus', { panel: 'category', menuIndex: menuIndex, categoryIndex: -1})
						}
					>
						Create New Category
					</TabItem>
					</TabGroup>
				)}
			</MenuList>)}
			</>
		);
	};
	list_dish = (menuIndex: number, categoryIndex: number) => {
		const { selected_dishes, activeMenuColorModal, targetIndex, targetItem } = this.state;
		const { mode } = this.state;
		const r = this.injected.store.restaurant!;
		const rs = this.injected.store.restaurant_stock!;
		const menu = r.menus[menuIndex];
		const category = menu.categories[categoryIndex];
		const currency = this.injected.store.intl.s.currency;
		const { pausedMenuItems, openMenuListItemActive, setOpenMenuListItemActive  } = this.injected.store;
		const { store } = this.injected;
		const { activeMobileMenu, setActiveMobileModal } = store;
		return (
			<>
			{(activeMobileMenu.name !== 'create-item' && activeMobileMenu.name !== 'edit-item') && (<MenuList id={category._id} type={MENU_ITEM_TYPE.DISH}>
				{(category.dishes || []).map((item: any, i: number) => {
					const stock = rs.dishes[item._id];
					let tag;

					if (item.status) {
						tag =
							item.status === "hidden"
								? "Hidden"
								: item.status === "no-stock"
									? "No Stock"
									: undefined;
					} else if (typeof stock !== "undefined") {
						tag = stock <= 0 ? `No Stock` : `${stock} units`;
					}

					const isPausing = pausedMenuItems.length > 0 && !!pausedMenuItems.find(d => normalizeObject(d)?.id === item._id)

					return (
						<MenuListItemV2
							key={item._id || 'item-'+i}
							id={item._id || 'item-'+i}
							onMoreAction={() => this.openItemMoreActions(i, categoryIndex, menuIndex, 'item')}
							type={MENU_ITEM_TYPE.DISH}
							mode={mode}
							isMenu
							name={
								<div className="flex-l-r-center width100" style={{ gap: 12 }}>
									<div className="flex-line centered" style={{ gap: 8, minWidth: 0, flex: 1 }}>
										{mode === "normal" && (
											<Checkbox
												id={`dish-${item._id}`}
												checked={
													selected_dishes.indexOf(
														item._id
													) !== -1
												}
												onChange={(e) => {
													e.stopPropagation();
													this.toggle_selected_dish(
														item._id
													);
												}}
											/>
										)}
										<MenuCardTitle >
											<TextEllipsis>{isObject(item.name) ? JSON.stringify(item.name): item.name}</TextEllipsis>
										</MenuCardTitle>
									</div>

									{tag && <Tag className="m-r-2" style={{ flexShrink: 0 }}>{tag}</Tag>}
								</div>
							}
							index={i}
							buttons={
								(r.reseller_id === "curbsidepivot" &&
									<Tooltip text="Stock" width={60} position="top">
										<ItemButton
											type="button"
											color="white"
											className="no-round no-border width32"
											paddinglr={5}
											onClick={(e) => {
												e.stopPropagation();
												this.dish_stock_update(item._id);
											}}
										>
										</ItemButton>
									</Tooltip>
								)
							}
							price={item.price}
							onEdit={() =>
							{ this.setPanel("item", [menuIndex, categoryIndex, i]);
								store.setActiveMobileMenu('edit-item', 'menus', {panel: 'item', menuIndex: menuIndex, categoryIndex: categoryIndex, dishIndex: i})
							}}
							onPause={() =>
								this.setOnPause("item", [
									menuIndex,
									categoryIndex,
									i,
								], item._id, item, [item])
							}
							onCopy={() =>
								this.modal_copy_open("item", [
									menuIndex,
									categoryIndex,
									i,
								])
							}
							currency={currency}
							onPriceEdit={(price) => {
								r.menus[menuIndex].categories[
									categoryIndex
								].dishes[i].price = price;
							}}
							isPausing={isPausing}
							isPauseInfinity={item?.pause_infinite}
							pauseDuration={item.pause_duration}
							pauseStart={item.pause_start}
							isItem
							toggleActiveMobileModal={() => setActiveMobileModal('desktop-printer-assign-items')}
						>
							{this.state.showBottomControl === 'item' && (
								<BottomMenuControls
									onEdit={() =>
										{ this.setPanel("item", [menuIndex, categoryIndex, i]);
											store.setActiveMobileMenu('edit-item', 'menus', {panel: 'item', menuIndex: menuIndex, categoryIndex: categoryIndex, dishIndex: i})
										}}
									onCopy={() =>
										this.modal_copy_open("item", [
											menuIndex,
											categoryIndex,
											i,
										])}
									onCancel={() => this.setState({ activeMobile: '', showBottomControl: '' })}
							/>
							)}
						</MenuListItemV2>
					);
				})}
				{mode === "normal" && (
					<TabGroup className='menus menus-end menus-header' style={{ overflow: 'unset', justifyContent: 'end'}}>
						<TabItem
							onClick={() => store.setActiveMobileMenu('create-item', 'menus', { panel: 'item', menuIndex: menuIndex, categoryIndex: categoryIndex, dishIndex: -1})}
						>
							Create New Item
						</TabItem>
					</TabGroup>
				)}
			</MenuList>)}
			</>
		);
	};

	//v2

	list_menu_v2 = () => {
		const { store } = this.injected;
		const { activeMobileMenu, openMenuListItemActive, openMenuBottomMenuControl, setOpenMenuListItemActive, setOpenMenuBottomMenuControl } = store;
		const {
			loading: loading,
			mode,
			activeMenuColorModal,
			activeMenuPrevisibilityModal,
		} = this.state;
		const r = this.injected.store.restaurant!;
		const { menus_v2 } = r;
		const { pausedMenuItems } = this.injected.store;

		const menuIds = pausedMenuItems.map(dish => dish?.menu_id);
		const menus = menus_v2 || [];
		if(loading) return <RotateLoader size={4} />
		return (
			<>
				{(activeMobileMenu.name !== 'create-menu'
				&& activeMobileMenu.name !== 'edit-menu'
				&& activeMobileMenu.name !== 'create-category'
				 && activeMobileMenu.name !== 'edit-category'
				 && activeMobileMenu.name !== 'create-item'
				 && activeMobileMenu.name !== 'edit-item') && (
					<>

					<MenuList id="menu-list" type={MENU_ITEM_TYPE.MENU} mode={mode}>
					{menus.map((menu: T.Schema.Restaurant.Menu.RestaurantMenuV2, i: number) => {
						const totalItems = menu.items.length
						return (

							<MenuListItemV2
								key={menu.id}
								type={MENU_ITEM_TYPE.MENU}
								id={menu.id}
								conditions={menu.availabilities.find(a => a.id === menu.availability_id)}
								mode={mode}
								onMoreAction={this.openMenuMoreActions}
								onClick={() => {
									const isAlreadyOpen = openMenuListItemActive === menu.id || (openMenuListItemActive && openMenuListItemActive.startsWith(menu.id + '_'));
									if (isAlreadyOpen) {
										setOpenMenuListItemActive('');
									} else {
										setOpenMenuListItemActive(menu.id);
									}
								}}
								active={(openMenuListItemActive === menu.id || (openMenuListItemActive && openMenuListItemActive.startsWith(menu.id + '_'))) ? menu.id : ''}
								activeVisibility={activeMenuPrevisibilityModal}
								toggleActiveVisibility={() => {
									setOpenMenuListItemActive(menu.id);
									setOpenMenuBottomMenuControl('menu');
									this.setState({
										preOverrideContext: {
											targetEntity: {
												type: 'menu',
												name: menu.name,
												categoryCount: menu.categories.length,
												itemCount: menu.items.length,
												conditions: menu.availabilities.find(a => a.id === menu.availability_id),
											},
											overrideSource: { menuId: menu.id },
										},
										activeMenuPrevisibilityModal: true,
									});
								}}
								toggleActiveMobileModal={() => {
									this.injected.store.setActiveMobileModal('desktop-printer-settings')}
								}
								isMenu
								name={
									<div className="flex-line centered" style={{gap: 8}}>
										{mode === 'normal' && <MenuItemColor
											color={menu.color || ''}
											onClick={(e) => {
												e.preventDefault()
												e.stopPropagation()
												this.setState({
													activeMenuColorModal: !activeMenuColorModal,
													activeMenuColorTitle: menu.name,
													targetItem: 'menu',
													targetIndex: i,
													menuColorBulkItemIds: null,
													activeMenuColorData: {
														color: menu.color!,
														media_url: menu.media_url,
														title: menu.name
													}
												})
											}}/>}
										<TextEllipsis>{menu.name}</TextEllipsis>
									</div>
								}
								index={i}
								onEdit={() => { store.setActiveMobileMenu('edit-menu', 'menus', {panel: 'menu', index: i});}}
								onRemove={() =>
									this.modal_remove_open("menu", [i])
								}
								onCopy={() => this.modal_copy_open("menu", [i])}
								isPausing={menuIds.includes(menu.id)}
								totalItems={totalItems}
								totalPausedItems={pausedMenuItems.filter(pausedItem => pausedItem?.menu_id === menu.id).length}
							>
								{this.list_category_v2(i)}

							</MenuListItemV2>
						);
					})}
					</MenuList>
					{mode === "normal" && (
						<>
							{menus.length > 0 ? (
								<TabGroup className='menus menus-end menus-header' style={{ overflow: 'unset', marginTop: 10}}>
									{this.generateCreateMenuButton()}

										<TabItem
											key="btn-re-arrange"
											onClick={() =>
												this.startEditMode("reOrder")
											}
											className="footer-button"
											style={{ height: '42px' }}
										>
											Re-Arrange
										</TabItem>

										<TabItem
											key="btn-edit-prices"
											onClick={() =>
												this.startEditMode("editPrices")
											}
											className="footer-button"
											style={{ height: '42px' }}
										>
											Edit Prices
										</TabItem>
								</TabGroup>
							) : (
								this.generateCreateMenuButton()
							)}
						</>
					)}

					{mode === "reOrder" &&
						this.saveCancelGroupButton(
							() =>
								this.saveEditMode("Menu Re-arranged Successfully!"),
							this.cancelEditMode,
							loading,
							"Re-Arrange Mode\n\nClick + hold to drag and drop items to re-order them"
						)}

					{mode === "editPrices" &&
						this.saveCancelGroupButtonV2(
							() => this.saveEditMode("Prices Updated Successfully!"),
							this.cancelEditMode,
							loading,
						"Bulk Edit Prices Mode"
					)}

					</>)}
			</>
		);
	};
	list_category_v2 = (menuIndex: number) => {
		const { mode, activeMenuColorModal, targetIndex, targetItem, activeMenuPrevisibilityModal } = this.state;
		const r = this.injected.store.restaurant!;
		const menu = (r.menus_v2 || [])[menuIndex];
		const { pausedMenuItems } = this.injected.store;
		const pauseIds = pausedMenuItems.map(d => d?._id);
		const { store } = this.injected;
		const { activeMobileMenu, openMenuListItemActive, openMenuBottomMenuControl, setOpenMenuListItemActive, setOpenMenuBottomMenuControl } = store;

		const checkCateIsPausing = (category: T.Schema.Restaurant.Menu.RestaurantCategoryV2) => {
			const items = menu.items.filter(item => item.category_id === category.id)
			return items.map(cate => cate.id).filter(d => pauseIds.includes(d)).length
		};
		return (
			<>
			{(activeMobileMenu.name !== 'create-category' && activeMobileMenu.name !== 'edit-category') && (
			<MenuList id={menu.id} type={MENU_ITEM_TYPE.CATEGORY}>
				{menu.categories.map((category:  T.Schema.Restaurant.Menu.RestaurantCategoryV2, i: number) => {
					const totalItems = menu.items.filter(item => item.category_id === category.id).length;
					const isAbacusOpenItemsAvailable =
						!!r.abacus?.abacus_status &&
						!!r.abacus?.abacus_open_items;

					const noAbacusOpenItem =
						//@ts-ignore
						isAbacusOpenItemsAvailable && !category.abacus_open_item
							? "No Abacus Open Item"
							: "";
					return (
						<MenuListItemV2
							key={category.id}
							id={category.id}
							conditions={menu.availabilities.find(a => a.id === category.availability_id)}
							type={MENU_ITEM_TYPE.CATEGORY}
							onClick={() => {
								const categoryKey = menu.id + '_' + category.id;
								const isAlreadyOpen = openMenuListItemActive === categoryKey || (openMenuListItemActive && openMenuListItemActive.startsWith(categoryKey + '_'));
								if (isAlreadyOpen) {
									setOpenMenuListItemActive(menu.id);
								} else {
									setOpenMenuListItemActive(categoryKey);
								}
							}}
							onMoreAction={() => this.openCategoryMoreActions(i, menuIndex, 'category')}
							active={((openMenuListItemActive === menu.id + '_' + category.id) || (openMenuListItemActive && openMenuListItemActive.startsWith(menu.id + '_' + category.id + '_'))) ? category.id : ''}
							activeVisibility={activeMenuPrevisibilityModal}
							toggleActiveVisibility={() => {
								const categoryKey = menu.id + '_' + category.id;
								setOpenMenuListItemActive(categoryKey);
								setOpenMenuBottomMenuControl('category');
								this.setState({
									preOverrideContext: {
										targetEntity: {
											type: 'category',
											name: category.name,
											categoryCount: menu.categories.length,
											itemCount: totalItems,
											conditions: menu.availabilities.find(a => a.id === category.availability_id),
										},
										overrideSource: { menuId: menu.id, categoryId: category.id },
									},
									activeMenuPrevisibilityModal: true,
								});
							}}
							toggleActiveMobileModal={() => store.setActiveMobileModal('desktop-printer-settings')}
							mode={mode}
							isMenu
							name={
								<div className="flex-l-r-center width100">
									<div className="flex-line centered" style={{gap: 8}}>
										{ mode !== 'editPrices' && (
										<MenuItemColor
											color={category.color || menu.color}
											onClick={(e) => {
												e.preventDefault()
												e.stopPropagation()
												this.setState({
													activeMenuColorModal: !activeMenuColorModal,
													activeMenuColorTitle: category.name,
													targetItem: 'category',
													targetIndex: i,
													targetMenuIndex: menuIndex,
													menuColorBulkItemIds: null,
													activeMenuColorData:  {
														color: category.color || menu.color || '',
														media_url: category.media_url,
														title: category.name
													}
												})
											}} />
										)}
										<MenuCardTitle>
											<TextEllipsis>{category.name}</TextEllipsis>
										</MenuCardTitle>
									</div>

									{noAbacusOpenItem &&
										<Tooltip text="Please edit this category and set the Abacus Open Item" width={360} position="top">
											<Tag className="m-r-2">{noAbacusOpenItem}</Tag>
										</Tooltip>
									}
								</div>
							}
							index={i}
							onEdit={() =>
								{ this.setPanel("category", [menuIndex, i]);  store.setActiveMobileMenu('edit-category', 'menus', {panel: 'category', menuIndex: menuIndex, categoryIndex: i});}
							}
							onRemove={() =>
								this.modal_remove_open("category", [
									menuIndex,
									i,
								])
							}
							onCopy={() =>
								this.modal_copy_open("category", [menuIndex, i])
							}
							isPausing={!!checkCateIsPausing(category)}
							totalItems={totalItems}
							totalPausedItems={checkCateIsPausing(category)}
						>
							{this.list_dish_v2(menuIndex, i)}

						</MenuListItemV2>
					);
				})}
				{mode === "normal" && (
					<TabGroup className='menus menus-end menus-header' style={{ overflow: 'unset', justifyContent: 'end'}}>
						<TabItem
						onClick={() => store.setActiveMobileMenu('create-category', 'menus', { panel: 'category', menuIndex: menuIndex, categoryIndex: -1})
						}
					>
						Create New Category
					</TabItem>
					</TabGroup>
				)}
			</MenuList>)}
			</>
		);
	};
	list_dish_v2 = (menuIndex: number, categoryIndex: number) => {
		const { selected_dishes, activeMenuColorModal, targetIndex, targetItem, activeMenuPrevisibilityModal } = this.state;
		const { mode } = this.state;
		const r = this.injected.store.restaurant!;
		const rs = this.injected.store.restaurant_stock!;
		const menu = (r.menus_v2 || [])[menuIndex];
		const category = menu.categories[categoryIndex];
		const currency = this.injected.store.intl.s.currency;
		const { pausedMenuItems } = this.injected.store;
		const { store } = this.injected;
		const { activeMobileMenu, setActiveMobileModal, openMenuListItemActive, openMenuBottomMenuControl, setOpenMenuListItemActive, setOpenMenuBottomMenuControl } = store;
		const items = menu.items.filter(item => item.category_id === category.id)
		return (
			<>
			{(activeMobileMenu.name !== 'create-item' && activeMobileMenu.name !== 'edit-item') && (<MenuList id={category.id} type={MENU_ITEM_TYPE.DISH}>
				{items.map((item: T.Schema.Restaurant.Menu.RestaurantItem, i: number) => {
					const stock = rs.dishes[item.id];
					let tag;

					if (item.status) {
						tag = item.status === "hidden" ? "Hidden"
								: item.status === "no-stock" ? "No Stock"
									: undefined;
					} else if (typeof stock !== "undefined") {
						tag = stock <= 0 ? `No Stock` : `${stock} units`;
					}

          const isPausing = item.pause?.infinite || item.pause?.start != null || pausedMenuItems.some(d => normalizeObject(d)?.id === item.id)
					const pauseStartMs = item.pause?.start != null ? new Date(item.pause.start).getTime() : undefined

					return (
						<MenuListItemV2
							key={item.id}
							id={item.id}
							conditions={menu.availabilities.find((a: any) => a.id === (item.availability_id ?? category.availability_id ?? menu.availability_id))}
							onMoreAction={() => this.openItemMoreActions(i, categoryIndex, menuIndex, 'item')}
							activeVisibility={activeMenuPrevisibilityModal}
							toggleActiveVisibility={() => {
								const itemKey = menu.id + '_' + category.id + '_' + item.id;
								setOpenMenuListItemActive(itemKey);
								setOpenMenuBottomMenuControl('item');
								this.setState({
									preOverrideContext: {
										targetEntity: {
											type: 'item',
											name: item.name,
											conditions: menu.availabilities.find((a: any) => a.id === (item.availability_id ?? category.availability_id ?? menu.availability_id)),
										},
										overrideSource: { menuId: menu.id, categoryId: category.id, itemId: item.id },
									},
									activeMenuPrevisibilityModal: true,
								});
							}}
							type={MENU_ITEM_TYPE.DISH}
							mode={mode}
							isMenu
							name={
								<div className="flex-l-r-center width100" style={{ gap: 12 }}>
									<div className="flex-line centered" style={{ gap: 8, minWidth: 0, flex: 1 }}>
										{mode === "normal" && (
											<Checkbox
												id={`dish-${item.id}`}
												checked={
													selected_dishes.indexOf(
														item.id
													) !== -1
												}
												onChange={(e) => {
													e.stopPropagation();
													this.toggle_selected_dish(
														item.id
													);
												}}
											/>
										)}
										{store.isNewMenuSchema && mode === 'normal' && <MenuItemColor
											color={item.color || category.color || menu.color}
											onClick={(e) => {
												e.preventDefault()
												e.stopPropagation()
												const bulkIds =
													selected_dishes.length > 0 && selected_dishes.indexOf(item.id) !== -1
														? [...selected_dishes]
														: null;
												this.setState({
													activeMenuColorModal: !activeMenuColorModal,
													activeMenuColorTitle:
														bulkIds && bulkIds.length > 1 ? `${bulkIds.length} items` : item.name,
													targetItem: 'item',
													targetIndex: i,
													targetMenuIndex: menuIndex,
													targetCategoryIndex: categoryIndex,
													menuColorBulkItemIds: bulkIds,
													activeMenuColorData:  {
														color: item.color || category.color || '',
														media_url: item.media_url || ''
													}

												})
											}} /> }
										<MenuCardTitle >
											<TextEllipsis>{item.name}</TextEllipsis>
										</MenuCardTitle>
									</div>

									{tag && mode === 'normal' && <Tag className="m-r-2" style={{ flexShrink: 0 }}>{tag}</Tag>}
								</div>
							}
							index={i}
							buttons={
								(r.reseller_id === "curbsidepivot" &&
									<Tooltip text="Stock" width={60} position="top">
										<ItemButton
											type="button"
											color="white"
											className="no-round no-border width32"
											paddinglr={5}
											onClick={(e) => {
												e.stopPropagation();
												this.dish_stock_update(item.id);
											}}
										>
										</ItemButton>
									</Tooltip>
								)
							}
							price={item.price}
							onEdit={() =>
							{ this.setPanel("item", [menuIndex, categoryIndex, i]);
								store.setActiveMobileMenu('edit-item', 'menus', {panel: 'item', menuIndex: menuIndex, categoryIndex: categoryIndex, dishIndex: i})
							}}
							onPause={() =>
								this.setOnPause("item", [
									menuIndex,
									categoryIndex,
									i,
								], item.id, item, [item])
							}
							onCopy={() =>
								this.modal_copy_open("item", [
									menuIndex,
									categoryIndex,
									i,
								])
							}
							onRemove={() =>
								this.modal_remove_open("item", [
									menuIndex,
									categoryIndex,
									i
								])
							}
							currency={currency}
							onPriceEdit={(price) => {
								(r.menus_v2 || [])[menuIndex].items[i].price = price;
							}}
							isPausing={isPausing}
							isPauseInfinity={item.pause?.infinite}
							pauseDuration={item.pause?.duration}
							pauseStart={pauseStartMs}
							isItem
							toggleActiveMobileModal={() => this.openPrinterAssignForItem(menuIndex, categoryIndex, menu.id, category.id, item.id)}
						>
						</MenuListItemV2>
					);
				})}
				{mode === "normal" && (
					<TabGroup className='menus menus-end menus-header' style={{ overflow: 'unset', justifyContent: 'end'}}>
						<TabItem
							onClick={() => store.setActiveMobileMenu('create-item', 'menus', { panel: 'item', menuIndex: menuIndex, categoryIndex: categoryIndex, dishIndex: -1})}
						>
							Create New Item
						</TabItem>
					</TabGroup>
				)}
			</MenuList>)}
			</>
		);
	};

	panel_menu = () => {
		const r = this.injected.store.restaurant!;
		const { store } = this.injected;
		const { activeMobileMenu } = store;
		const { panel, panel_index } = this.state;
		const [menuIndex, categoryIndex, dishIndex] = panel_index;
		const active = activeMobileMenu?.data?.panel === 'menu';
		let initialValues = null;
		if (active) {
			if (store.activeMobileMenu?.data?.index === -1) {
				// When creating a new menu, use the correct schema
				// shape for the currently active menu version.
				initialValues = store.isNewMenuSchema
					? this.create_menu_v2()
					: this.create_menu();
			} else {
				let item: any;
				if (store.isNewMenuSchema) {
					const targetMenu = (r.menus_v2 || [])[store.activeMobileMenu?.data?.index];
					const targetAvailability = targetMenu.availabilities.find(a => a.id === targetMenu.availability_id);
					console.log('targetAvailability', targetAvailability)
					console.log('targetMenu', toJS(targetMenu))
					item = {
						...targetMenu,
						conditions: targetAvailability,
						availability_id: targetMenu.availability,
						availability: targetAvailability,
					};
				} else {
					item = r.menus[store.activeMobileMenu?.data?.index];
				}
				initialValues = cloneDeep(item);
			}
		}

		return (
			<RestaurantFormMenuV2
				type={activeMobileMenu.data?.index === -1 ? "create" : "edit"}
				initialValues={initialValues}
				close={() => this.setPanel(null, [])}
			/>
		);
	};

	panel_category = () => {
		const r = this.injected.store.restaurant!;
		const { panel, panel_index } = this.state;
		const [menuIndex, categoryIndex] = panel_index;
		const { store } = this.injected;
		const { activeMobileMenu } = store;
		const active = activeMobileMenu?.data?.panel === "category";

		let initialValues = null;
		if (active) {
			let menu, item;
			menu = r.menus[activeMobileMenu?.data?.menuIndex];
			if (activeMobileMenu?.data?.categoryIndex === -1) {
				if(store.isNewMenuSchema) {
					menu = (r.menus_v2 || [])[activeMobileMenu?.data?.menuIndex];
					initialValues = this.create_category(menu.id);
				} else {
					initialValues = this.create_category(menu._id);
				}
			} else {
				if(store.isNewMenuSchema) {
					const targetCategory = (r.menus_v2 || [])[activeMobileMenu?.data?.menuIndex].categories[activeMobileMenu?.data?.categoryIndex]
					const targetAvailability = (r.menus_v2 || [])[activeMobileMenu?.data?.menuIndex].availabilities.find(a => a.id === targetCategory.availability_id);
						menu = (r.menus_v2 || [])[activeMobileMenu?.data?.menuIndex];
						item = {
							...menu.categories[activeMobileMenu?.data?.categoryIndex],
							availability_id: targetCategory.availability_id,
							conditions: targetAvailability,
							availability: targetAvailability
						};
				} else {
					item = menu.categories[activeMobileMenu?.data?.categoryIndex];
				}
				initialValues = cloneDeep(item);
			}
		}

		console.log('initialValues category', initialValues)
		return (
			<RestaurantFormCategoryV2
				type={activeMobileMenu?.data?.categoryIndex === -1 ? "create" : "edit"}
				menuIndex={activeMobileMenu?.data?.menuIndex}
				initialValues={initialValues}
				close={() => this.setPanel(null, [])}
			/>
		);
	};

	panel_dish = () => {
		const r = this.injected.store.restaurant!;
		const { panel, panel_index } = this.state;
		const [menuIndex, categoryIndex, dishIndex] = panel_index;
		const { store } = this.injected;
		const { activeMobileMenu } = store;
		const active = activeMobileMenu?.data?.panel === "item";
		let initialValues = null;
		if (active) {
			let menu;
			let category: T.Schema.Restaurant.Menu.RestaurantCategory | T.Schema.Restaurant.Menu.RestaurantCategoryV2 | null = null;
			let item;
			if (activeMobileMenu?.data?.dishIndex === -1) {
				if(store.isNewMenuSchema) {
					//@ts-ignore
					menu = (r.menus_v2 || [])[activeMobileMenu?.data?.menuIndex];
					//@ts-ignore
					category = menu.categories[activeMobileMenu?.data?.categoryIndex];
					//@ts-ignore
					initialValues = this.create_dish(menu.id, category.id);
				} else {
					menu = r.menus[activeMobileMenu?.data?.menuIndex];
					category = menu.categories[activeMobileMenu?.data?.categoryIndex];
					initialValues = this.create_dish(menu._id, category._id);
				}
			} else {
				if(!store.isNewMenuSchema) {
					menu = r.menus[activeMobileMenu?.data?.menuIndex];
					category = menu.categories[activeMobileMenu?.data?.categoryIndex];
					item = category.dishes[
							activeMobileMenu?.data?.dishIndex
						];
					item = cloneDeep(item);
					item.taxes = [];
				} else {
					//@ts-ignore
					menu = (r.menus_v2 || [])[activeMobileMenu?.data?.menuIndex];
					category = menu.categories[activeMobileMenu?.data?.categoryIndex];
					//@ts-ignore
          			const targetItem = menu.items.filter(item => item.category_id === category.id)[activeMobileMenu?.data?.dishIndex]
		  			const targetAvailability = menu.availabilities.find(a => a.id === targetItem.availability_id);

					console.log('targetItem', toJS(targetItem), toJS(activeMobileMenu?.data?.dishIndex))
					//@ts-ignore
					item = {
						...targetItem,
						conditions: targetAvailability,
						availability_id: targetItem.availability_id,
						availability: targetAvailability,
						option_sets: targetItem.modifiers,
						image: CoreUtils.image.ucReverse(targetItem.media_url),
						taxes: (targetItem.taxes || []).map((t: any) =>
							typeof t === 'string' ? t : getId(t)
						),
					}
				}
				initialValues = cloneDeep(item);
			}
		}
		return (
			<RestaurantFormDishV2
				type={activeMobileMenu?.data?.dishIndex === -1 ? "create" : "edit"}
				menuIndex={activeMobileMenu?.data?.menuIndex}
				categoryIndex={activeMobileMenu?.data?.categoryIndex}
				//@ts-ignore
				initialValues={initialValues}
			/>
		);
	};

	sidebar_panel_dish = () => {
		const { panel_pause, currentMenuItemId, currentMenuItem, currentMenuItems } = this.state;
		const handleCloseSidebar = () => {
			this.setOnPause(null, [], "", null, []);
			this.setState({
				selected_dishes: [],
				bulkSelectedDishesSheetDismissed: false,
			});
		}
		const r = this.injected.store.restaurant!;
		const openHours = r.location && r.location.opening_hours ? r.location.opening_hours : [];
		const specialHours = r.location && r.location.special_hours ? r.location.special_hours : [];

		const nextDayOpenTime = getNextDayOpenTime(openHours, specialHours);
		return (
			<PauseSidebar
				isOpen={panel_pause === MENU_COMPONENTS.ITEM}
				close={handleCloseSidebar}
				panel={MENU_COMPONENTS.ITEM}
				currentMenuItemId={currentMenuItemId}
				//@ts-ignore
				currentMenuItem={currentMenuItem}
				//@ts-ignore
				currentMenuItems={currentMenuItems}
				nextDayOpenTime={nextDayOpenTime}
			/>
		);
	};

	modal_copy = () => {
		const { store } = this.injected;
		const r = store.restaurant!;
		const { copy_type, copy_index, copy_loading } = this.state;

		const [menuIndex, categoryIndex, dishIndex] = copy_index;

		let item;
		let copyFn;
		const menus_v2 = r.menus_v2 || [];
		if (copy_type === "menu") {
			if(store.isNewMenuSchema) {
				item = menus_v2[menuIndex];
			} else {
				item = r.menus[menuIndex];
			}
			copyFn = () => this.menu_copy(menuIndex);
		} else if (copy_type === "category") {
			if(store.isNewMenuSchema) {
				item = menus_v2[menuIndex].categories[categoryIndex]
			} else {
				item = r.menus[menuIndex].categories[categoryIndex];
			}
			copyFn = () => this.category_copy(menuIndex, categoryIndex);
		} else if (copy_type === "item") {
			if(store.isNewMenuSchema) {
				item = menus_v2[menuIndex].items[dishIndex];
			} else {
				item = r.menus[menuIndex].categories[categoryIndex].dishes[dishIndex];
			}
			copyFn = () => this.dish_copy(menuIndex, categoryIndex, dishIndex);
		}

		if(!item) return null
		return (
			<Modal
				width="sm"
				close={this.modal_copy_close}
				closeButton={false}
				active={!!item}
			>
				<ModalContent className="flex-l-r-center">
					<h4 className="">Copy {copy_type}</h4>
					<p className="big underline">
						{ item.name }
					</p>
				</ModalContent>
				<ModalContent className="flex-right">
					<Button
						type="button"
						className="m-r-2 width100 max100px"
						onClick={this.modal_copy_close}
					>
						Cancel
					</Button>
					<Button
						type="button"
						className="width100 max100px"
						color="primary"
						onClick={copyFn}
					>
						{copy_loading && (
							<RotateLoader size={2} color="white" />
						)}
						{!copy_loading && "Copy"}
					</Button>
				</ModalContent>
			</Modal>
		);
	};
	modal_remove = () => {
		const { store } = this.injected;
		const r = store.restaurant!;
		const { remove_type, remove_index, remove_loading } = this.state;

		const [menuIndex, categoryIndex, dishIndex] = remove_index;

		let item;
		let removeFn;
		const menus_v2 = r.menus_v2 || [];
		if (remove_type === "menu") {
			if(store.isNewMenuSchema) {
				item = menus_v2[menuIndex];
			} else {
				item = r.menus[menuIndex];
			}
			removeFn = () => this.menu_remove(menuIndex);
		} else if (remove_type === "category") {
			if(store.isNewMenuSchema) {
				item = menus_v2[menuIndex].categories[categoryIndex];
			} else {
				item = r.menus[menuIndex].categories[categoryIndex];
			}
			removeFn = () => this.category_remove(menuIndex, categoryIndex);
		} else if (remove_type === "item") {
			let dishId: string;
			if(store.isNewMenuSchema) {
				item = menus_v2[menuIndex].items[dishIndex];
				if(item) {
					dishId = item.id;
				}
			} else {
				item = r.menus[menuIndex].categories[categoryIndex].dishes[dishIndex];
				if(item) {
					dishId = item._id;
				}
			}
			removeFn = () => this.dish_remove(menuIndex, categoryIndex, dishIndex, dishId);
		}

		if(!item) return null
		return (
			<Modal
				width="sm"
				close={this.modal_remove_close}
				closeButton={false}
				active={!!item}
			>
				<ModalContent className="flex-l-r-center">
					<h4 className="">Delete {remove_type}</h4>
					<p className="big underline">
						{ item.name }
					</p>
				</ModalContent>
				<ModalContent className="flex-right">
					<Button
						type="button"
						className="m-r-2 width100 max100px"
						onClick={this.modal_remove_close}
					>
						Cancel
					</Button>
					<Button
						type="button"
						className="width100 max100px"
						color="primary"
						onClick={removeFn}
					>
						{remove_loading && (
							<RotateLoader size={2} color="white" />
						)}
						{!remove_loading && "Delete"}
					</Button>
				</ModalContent>
			</Modal>
		);
	};
	menu_copy = async (menuIndex: number) => {
		const { store } = this.injected;
		const r = store.restaurant!;
		if(store.isNewMenuSchema) {
			try {
				const menu = cloneDeep((r.menus_v2 || [])[menuIndex]);
				const menu_id = shortid.generate();
				menu.id = menu_id;
				//@ts-ignore
				menu.name = `${ menu.name } - Copy`;
				//@ts-ignore
				menu.description = menu.description?.en || '';
				this.setState({
					copy_loading: true
				});
				const menuCreated = await store.api.menu_create_menu({
					restaurant_id: r?._id,
					menu: menu
				});
				store.updateRestaurant({
					menus_v2: (r.menus_v2 || []).concat(menuCreated)
				});
				UI.notification.success("Menu copied")
			} catch(e) {
				UI.notification.error(e.error)
			}
			this.modal_copy_close();
		} else {
			await this.copy({
				successMsg: "Menu copied",
				process: (r) => {
					const menu = cloneDeep(r.menus[menuIndex]);
					const menu_id = shortid.generate();
					menu._id = menu_id;
					menu.name = `${menu.name} - Copy`;
					for (let i = 0; i < menu.categories.length; i++) {
						const category_id = shortid.generate();
						menu.categories[i]._id = category_id;
						menu.categories[i].menu_id = menu_id;
						for (let k = 0; k < menu.categories[i].dishes.length; k++) {
							menu.categories[i].dishes[k]._id = shortid.generate();
							menu.categories[i].dishes[k].menu_id = menu_id;
							menu.categories[i].dishes[k].category_id = category_id;
						}
					}
					r.menus.splice(menuIndex + 1, 0, menu);
				},
			});
		}
	};
	menu_remove = async (menuIndex: number) => {
		const { store } = this.injected;
		const r = store.restaurant!;
		if(store.isNewMenuSchema) {
			const targetMenu = (r.menus_v2 || [])[menuIndex]
			console.log('targetMenu', targetMenu)
			this.setState({ remove_loading: true })
			try {
				const deleteRes = await store.api.menu_delete_menu({
					restaurant_id: r._id,
					menu_id: targetMenu.id
				})
				store.updateRestaurant({
					menus_v2: (r.menus_v2 || []).filter(m => m.id !== targetMenu.id)
				})

        if (deleteRes.error) {
          UI.notification.error(deleteRes.message);
          return;
        } else {
          UI.notification.success("Menu deleted");
        }
				this.modal_remove_close()
			} catch(e) {
				UI.notification.error(e.error)
			}
			this.setState({ remove_loading: false })
			return
		} else {
			await this.remove({
				successMsg: "Menu deleted",
				process: (r) => {
					r.menus.splice(menuIndex, 1);
				},
			});
		}
	};
	category_copy = async (menuIndex: number, categoryIndex: number) => {
		const { store } = this.injected;
		const r = store.restaurant!;
		if(store.isNewMenuSchema) {
			try {
				const menus = (r.menus_v2 || [])
				const menu = cloneDeep(menus[menuIndex]);
				const category = cloneDeep(menu.categories[categoryIndex]);
				const category_id = shortid.generate();
				category.id = category_id;
				//@ts-ignore
				category.name = `${category.name} - Copy`;
				//@ts-ignore
				category.description = `${category.description?.en || ''}`;
				this.setState({
					copy_loading: true
				});
				const categoryCreated = await store.api.menu_create_category({
					restaurant_id: r?._id,
					menu_id: menu.id,
					data: category
				});
				menu.categories.push(categoryCreated)
				menus[menuIndex] = menu
				store.updateRestaurant({
					menus_v2: menus
				});
				UI.notification.success("Category copied");
				this.modal_copy_close();
			} catch(e) {
				UI.notification.error(e.error)
			};
		} else {
			await this.copy({
				successMsg: "Category copied",
				process: (r) => {
					const menu = r.menus[menuIndex];
					const category = cloneDeep(menu.categories[categoryIndex]);
					const category_id = shortid.generate();
					category._id = category_id;
					category.name = `${category.name} - Copy`;
					for (let i = 0; i < category.dishes.length; i++) {
						category.dishes[i]._id = shortid.generate();
						category.dishes[i].category_id = category_id;
					}
					r.menus[menuIndex].categories.splice(
						categoryIndex + 1,
						0,
						category
					);
				},
			});
		}
	};
	category_remove = async (menuIndex: number, categoryIndex: number) => {
		const { store } = this.injected;
		const r = store.restaurant!;
		if(store.isNewMenuSchema) {
			const menus = (r.menus_v2 || [])
			const menu = cloneDeep(menus[menuIndex]);
			const category = cloneDeep(menu.categories[categoryIndex]);

			this.setState({ remove_loading: true })
			try {
				await store.api.menu_delete_category({
					restaurant_id: r._id,
					menu_id: menu.id,
					category_id: category.id
				})
				UI.notification.success("Category deleted")
				menu.categories = menu.categories.filter(c => c.id !== category.id)

				menus[menuIndex] = menu
				store.updateRestaurant({
					menus_v2: menus
				});
				this.modal_remove_close()
			} catch(e) {
				UI.notification.error(e.error)
			}
			this.setState({ remove_loading: false })
			return
		} else {
			await this.remove({
				successMsg: "Category deleted",
				process: (r) => {
					r.menus[menuIndex].categories.splice(categoryIndex, 1);
				},
			});
		}
	};
	dish_copy = async (
		menuIndex: number,
		categoryIndex: number,
		dishIndex: number
	) => {
		const { store } = this.injected;
		const r = store.restaurant!;
		if(store.isNewMenuSchema) {
			const menus = (r.menus_v2 || [])
			const menu = cloneDeep(menus[menuIndex]);
			const category = cloneDeep(menu.categories[categoryIndex]);
			const item = cloneDeep(menus[menuIndex].items[dishIndex]);
			item.id = shortid.generate();
			//@ts-ignore
			item.name = `${item.name} - Copy`;
			this.setState({
				copy_loading: true
			})
			try {

				const itemCreated = await store.api.menu_create_item({
					restaurant_id: r._id,
					menu_id: menu.id,
					category_id: category.id,
					data: item
				})
				menu.items.push(itemCreated)
				menus[menuIndex] = menu
				store.updateRestaurant({
					menus_v2: menus
				})
				UI.notification.success("Item copied")
				this.modal_copy_close()
			} catch(e) {
				UI.notification.error(e.error)
			}
			this.setState({
				copy_loading: false
			})

		} else {
			await this.copy({
				successMsg: "Item copied",
				process: (r) => {
					const item = cloneDeep(
						r.menus[menuIndex].categories[categoryIndex].dishes[
						dishIndex
						]
					);
					item._id = shortid.generate();
					item.name = `${item.name} - Copy`;
					r.menus[menuIndex].categories[categoryIndex].dishes.splice(
						categoryIndex + 1,
						0,
						item
					);
				},
			});
		}
	};
	dish_remove = async (
		menuIndex: number,
		categoryIndex: number,
		dishIndex: number,
		dishId: string
	) => {
		const { store } = this.injected;
		const r = store.restaurant!;
		if(store.isNewMenuSchema) {
			const menus = (r.menus_v2 || [])
			const menu = cloneDeep(menus[menuIndex]);
			const category = cloneDeep(menu.categories[categoryIndex]);
			console.log('dish remove dishid', dishId)
			this.setState({
				remove_loading: true
			})
			try {
				await store.api.menu_delete_item({
					restaurant_id: r._id,
					menu_id: menu.id,
					category_id: category.id,
					item_id: dishId
				})
				menu.items = menu.items.filter(item => item.id !== dishId)
				menus[menuIndex] = menu
				store.updateRestaurant({
					menus_v2: menus
				})
				this.modal_remove_close()
				UI.notification.success("Item deleted")
			} catch(e) {
				UI.notification.error(e.error)
			}
			this.setState({
				remove_loading: false
			})
		} else {
			await this.remove({
				successMsg: "Item deleted",
				dishId: dishId,
				process: (r) => {
					r.menus[menuIndex].categories[categoryIndex].dishes.splice(
						dishIndex,
						1
					);
				},
			});
		}
	};

	dish_stock_update = async (dishId: string) => {
		const inputValue = prompt(
			`Enter a numeric value for the stock quantity of this item. Leave blank to disable stock management`
		);

		if (inputValue === null) {
			return;
		}

		let value: "" | number;
		try {
			value = inputValue === "" ? "" : parseInt(inputValue);
		} catch (e) {
			UI.notification.error(
				"Please enter a numeric value or leave blank"
			);
			return;
		}

		const { store } = this.injected;

		try {
			Untrusive.start();
			const { stock } = await store.api.menu_stock_update({
				_id: store.restaurant!._id,
				items: [
					{
						_id: dishId,
						key: "dishes",
						value: value,
					},
				],
			});
			store.setRestaurantStock(stock);
			UI.notification.success("Stock updated");
		} catch (e) {
			logger.captureException(e);
			UI.notification.error("Something went wrong, try again");
		} finally {
			Untrusive.stop();
		}
	};

	copy = async (opts: {
		process: (r: T.Schema.Restaurant.RestaurantSchema) => void;
		successMsg: string;
	}) => {
		await this.saveRestaurant({
			successMsg: opts.successMsg,
			process: (r) => {
				opts.process(r);
				return {
					update: { $set: { menus: r.menus } },
				};
			},
			before: () => this.setState({ copy_loading: true }),
			onSuccess: () => this.modal_copy_close(),
			onFail: () => this.setState({ copy_loading: false }),
			onError: () => this.setState({ copy_loading: false }),
		});
	};
	remove = async (opts: {
		process: (r: T.Schema.Restaurant.RestaurantSchema) => void;
		successMsg: string;
		dishId?: string;
	}) => {
		await this.saveRestaurant({
			successMsg: opts.successMsg,
			process: (r) => {
				opts.process(r);
				return {
					update: { $set: { menus: r.menus } },
				};
			},
			before: () => this.setState({ remove_loading: true }),
			onSuccess: () => {
				this.modal_remove_close();
				if (opts.dishId) {
					this.injected.store.api
						.menu_stock_update({
							_id: this.injected.store.restaurant!._id,
							items: [
								{
									_id: opts.dishId,
									key: "dishes",
									value: "",
								},
							],
						})
						.catch(logger.captureException);
				}
			},
			onFail: () => this.setState({ remove_loading: false }),
			onError: () => this.setState({ remove_loading: false }),
		});
	};

	openPrinterAssignForItem = (menuIndex: number, categoryIndex: number, menuId: string, categoryId: string, itemId: string) => {
		this.setState({
			printerAssignTarget: { menuIndex, categoryIndex, itemId, menuId, categoryId },
			printerAssignBulkItemIds: null,
		});
		this.injected.store.setActiveMobileModal('desktop-printer-assign-items');
	};

	modal_copy_open = (type: MenuComponents, index: number[]) => {
		this.setState({
			copy_type: type,
			copy_index: index,
			copy_loading: false,
		});
	};
	modal_copy_close = () => {
		this.setState({
			copy_type: null,
			copy_index: [],
			copy_loading: false,
		});
	};
	modal_remove_open = (type: MenuComponents, index: number[]) => {
		this.setState({
			remove_type: type,
			remove_index: index,
			remove_loading: false,
		});
	};
	modal_remove_close = () => {
		this.setState({
			remove_type: null,
			remove_index: [],
			remove_loading: false,
		});
	};

	toggle_selected_dish = (dish_id: string) => {
		const prev = this.state.selected_dishes;
		const selected_dishes = [...prev];
		const index = selected_dishes.indexOf(dish_id);
		if (index === -1) selected_dishes.push(dish_id);
		else selected_dishes.splice(index, 1);
		const reopenSheet = prev.length === 0 && selected_dishes.length > 0;
		this.setState({
			selected_dishes,
			bulkSelectedDishesSheetDismissed: reopenSheet
				? false
				: selected_dishes.length === 0
					? false
					: this.state.bulkSelectedDishesSheetDismissed,
		});
	};
	float_button_cancel = () => {
		this.setState({
			selected_dishes: [],
			activeDeleteItemModal: false,
			bulkSelectedDishesSheetDismissed: false,
		});
	};
	closeBulkSelectedDishesSheet = () => {
		this.setState({ bulkSelectedDishesSheetDismissed: true });
	};
	/** Select every item in the same category as the first selected dish (matches list_dish_v2 scope). */
	bulkSelectAllInCategoryOfFirst = () => {
		const { selected_dishes } = this.state;
		if (selected_dishes.length === 0) return;
		const r = this.injected.store.restaurant!;
		const menus = r.menus_v2 || [];
		const found = findItemInMenusV2(menus, selected_dishes[0]);
		if (!found) return;
		const menu = menus[found.menuIndex];
		const catId = found.categoryId;
		const ids = (menu.items || [])
			.filter((i: any) => i.category_id === catId)
			.map((i: any) => i.id);
		this.setState({ selected_dishes: [...new Set(ids)] });
	};
	openBulkItemColorFromSheet = () => {
		const { selected_dishes } = this.state;
		if (selected_dishes.length === 0) return;
		const r = this.injected.store.restaurant!;
		const menus = r.menus_v2 || [];
		const found = findItemInMenusV2(menus, selected_dishes[0]);
		if (!found) return;
		const menu = menus[found.menuIndex];
		const category = menu.categories?.find((c: any) => c.id === found.categoryId);
		const categoryIndex = menu.categories?.findIndex((c: any) => c.id === found.categoryId) ?? -1;
		const { item } = found;
		const itemsInCat = (menu.items || []).filter((i: any) => i.category_id === found.categoryId);
		const dishIndex = itemsInCat.findIndex((i: any) => i.id === item.id);
		this.setState({
			activeMenuColorModal: true,
			activeMenuColorTitle:
				selected_dishes.length > 1 ? `${selected_dishes.length} items` : item.name,
			targetItem: 'item',
			targetIndex: dishIndex >= 0 ? dishIndex : 0,
			targetMenuIndex: found.menuIndex,
			targetCategoryIndex: categoryIndex >= 0 ? categoryIndex : 0,
			menuColorBulkItemIds: [...selected_dishes],
			activeMenuColorData: {
				color: item.color || category?.color || menu.color || '',
				media_url: item.media_url || '',
			},
			bulkSelectedDishesSheetDismissed: true,
		});
	};
	openBulkPrinterAssignFromSheet = () => {
		const refs = this.getSelectedItemRefsV2();
		if (refs.length === 0) return;
		const first = refs[0];
		const r = this.injected.store.restaurant!;
		const menus = r.menus_v2 || [];
		const menuIndex = menus.findIndex((m) => m.id === first.menu_id);
		if (menuIndex === -1) return;
		const menu = menus[menuIndex];
		const categoryIndex = menu.categories?.findIndex((c: any) => c.id === first.category_id) ?? -1;
		this.setState({
			printerAssignTarget: {
				menuIndex,
				categoryIndex,
				itemId: first.id,
				menuId: first.menu_id,
				categoryId: first.category_id,
			},
			printerAssignBulkItemIds: [...this.state.selected_dishes],
			bulkSelectedDishesSheetDismissed: true,
		});
		this.injected.store.setActiveMobileModal('desktop-printer-assign-items');
	};

	// Resolve selected item IDs to (menu_id, category_id, item_id) for v2 schema
	getSelectedItemRefsV2 = (): { menu_id: string; category_id: string; id: string }[] => {
		const r = this.injected.store.restaurant!;
		const menus = r.menus_v2 || [];
		const selectedSet = new Set(this.state.selected_dishes);
		const refs: { menu_id: string; category_id: string; id: string }[] = [];
		for (const menu of menus) {
			for (const item of menu.items || []) {
				if (selectedSet.has(item.id)) {
					refs.push({
						menu_id: menu.id,
						category_id: item.category_id,
						id: item.id,
					});
				}
			}
		}
		return refs;
	};

	// Menu v2: update status for selected items via menu_partial_update_item
	float_button_update_status_v2 = async (status: string | null) => {
		const { store } = this.injected;
		const r = store.restaurant!;
		const refs = this.getSelectedItemRefsV2();
		if (refs.length === 0) return;
		this.setState({ selected_loading: true });
		try {
      await store.api.menu_partial_update_batch_items({
        restaurant_id: r._id,
        data: {
          items: refs.map((item: any) => ({ ...item, status: status })),
        }
      })
			const menus = cloneDeep(r.menus_v2 || []);
			for (const menu of menus) {
				for (const item of menu.items || []) {
					if (this.state.selected_dishes.indexOf(item.id) !== -1) {
						item.status = status as any;
					}
				}
			}
			store.updateRestaurant({ menus_v2: menus });
			UI.notification.success("Item status set");
		} catch (e) {
			UI.notification.error((e as any)?.error ?? "Failed to update");
		} finally {
			this.setState({
				selected_loading: false,
				selected_dishes: [],
				bulkSelectedDishesSheetDismissed: false,
			});
		}
	};

	/** V2: delete selected items via menu_delete_item (called after modal confirm) */
	float_button_delete_v2 = async () => {
		const { store } = this.injected;
		const r = store.restaurant!;
		const refs = this.getSelectedItemRefsV2();
		if (refs.length === 0) {
			this.setState({
				activeDeleteItemModal: false,
				selected_dishes: [],
				bulkSelectedDishesSheetDismissed: false,
			});
			return;
		}
		this.setState({ remove_loading: true });
		try {
			await Promise.all(
				refs.map(({ menu_id, category_id, id }) =>
					store.api.menu_delete_item({
						restaurant_id: r._id,
						menu_id,
						category_id,
						item_id: id,
					})
				)
			);
			const menus = cloneDeep(r.menus_v2 || []);
			const selectedSet = new Set(this.state.selected_dishes);
			for (const menu of menus) {
				menu.items = (menu.items || []).filter((item) => !selectedSet.has(item.id));
			}
			store.updateRestaurant({ menus_v2: menus });
			UI.notification.success("Items deleted");
			this.setState({
				activeDeleteItemModal: false,
				selected_dishes: [],
				bulkSelectedDishesSheetDismissed: false,
			});
		} catch (e) {
			UI.notification.error((e as any)?.error ?? "Failed to delete");
		} finally {
			this.setState({ remove_loading: false });
		}
	};

	showDeleteItemsModal = () => {
		this.setState({
			activeDeleteItemModal: true,
			bulkSelectedDishesSheetDismissed: true,
		});
	};

	float_button_delete = async () => {
		const { store } = this.injected;
		if (store.isNewMenuSchema) {
			await this.float_button_delete_v2();
			return;
		}
		await this.float_button_process({
			successMsg: "Items deleted",
			process: (r, selected_dishes) => {
				for (const [i, menu] of r.menus.entries()) {
					for (const [k, category] of menu.categories.entries()) {
						r.menus[i].categories[k].dishes =
							category.dishes.filter(
								(dish) =>
									selected_dishes.indexOf(dish._id) === -1
							);
					}
				}
			},
		});
	};
	float_button_no_stock = async () => {
		const { store } = this.injected;
		if (store.isNewMenuSchema) {
			await this.float_button_update_status_v2("no-stock");
			return;
		}
		await this.float_button_process({
			successMsg: "Item status set",
			process: (r, selected_dishes) => {
				for (const [i, menu] of r.menus.entries()) {
					for (const [k, category] of menu.categories.entries()) {
						for (const [z, dish] of category.dishes.entries()) {
							if (selected_dishes.indexOf(dish._id) !== -1) {
								r.menus[i].categories[k].dishes[z].status =
									"no-stock";
							}
						}
					}
				}
			},
		});
	};
	float_button_hidden = async () => {
		const { store } = this.injected;
		if (store.isNewMenuSchema) {
			await this.float_button_update_status_v2("hidden");
			return;
		}
		await this.float_button_process({
			successMsg: "Item status set",
			process: (r, selected_dishes) => {
				for (const [i, menu] of r.menus.entries()) {
					for (const [k, category] of menu.categories.entries()) {
						for (const [z, dish] of category.dishes.entries()) {
							if (selected_dishes.indexOf(dish._id) !== -1) {
								r.menus[i].categories[k].dishes[z].status =
									"hidden";
							}
						}
					}
				}
			},
		});
	};
	float_button_available = async () => {
		const { store } = this.injected;
		if (store.isNewMenuSchema) {
			await this.float_button_update_status_v2('');
			return;
		}
		await this.float_button_process({
			successMsg: "Item status set",
			process: (r, selected_dishes) => {
				for (const [i, menu] of r.menus.entries()) {
					for (const [k, category] of menu.categories.entries()) {
						for (const [z, dish] of category.dishes.entries()) {
							if (selected_dishes.indexOf(dish._id) !== -1) {
								r.menus[i].categories[k].dishes[z].status =
									null;
							}
						}
					}
				}
			},
		});
	};
	float_button_process = async (opts: {
		process: (
			r: T.Schema.Restaurant.RestaurantSchema,
			selected_dishes: string[]
		) => void;
		successMsg: string;
	}) => {
		const { selected_dishes } = this.state;
		await this.saveRestaurant({
			successMsg: opts.successMsg,
			process: (r) => {
				opts.process(r, selected_dishes);
				return {
					update: { $set: { menus: r.menus } },
				};
			},
			before: () => this.setState({ selected_loading: true }),
			onSuccess: () =>
				this.setState({
					selected_loading: false,
					selected_dishes: [],
					bulkSelectedDishesSheetDismissed: false,
				}),
			onFail: () => this.setState({ selected_loading: false }),
			onError: () => this.setState({ selected_loading: false }),
		});
	};

	startEditMode = (mode: MenusEditMode) => {
		this.setState({ mode });
		const r = this.injected.store.restaurant!;
		this.menu_backup = cloneDeep(r.menus);
		if (this.injected.store.isNewMenuSchema && r.menus_v2?.length) {
			this.menu_backup_v2 = cloneDeep(r.menus_v2);
		} else {
			this.menu_backup_v2 = null;
		}
	};

	cancelEditMode = () => {
		const r = this.injected.store.restaurant!;
		if (this.injected.store.isNewMenuSchema && this.menu_backup_v2) {
			(this as any).injected.store.updateRestaurant({ menus_v2: this.menu_backup_v2 });
			this.menu_backup_v2 = null;
		} else {
			r.menus = this.menu_backup || [];
		}
		this.setState({ mode: "normal" });
	};

	saveEditMode = async (successMsg: string) => {
		const r = this.injected.store.restaurant!;
		const store = this.injected.store;

		if (store.isNewMenuSchema && r.menus_v2?.length) {
			const backup = cloneDeep(r);
			if (this.menu_backup_v2) backup.menus_v2 = this.menu_backup_v2;
			this.setState({ loading: true });
			try {
				//loop through each menu.items but only the updated ones
				const updatedItems = r.menus_v2.flatMap((menu: any) => menu.items.filter((item: any) => item.price !== this.menu_backup_v2?.find((m: any) => m.id === menu.id)?.items.find((i: any) => i.id === item.id)?.price));
        await store.api.menu_partial_update_batch_items({
          restaurant_id: r._id,
          data: {
            items: updatedItems.map((item: any) =>
              ({ id: item.id, menu_id: item.menu_id, category_id: item.category_id, price: item.price })),
          }
        })
				UI.notification.success(successMsg);
				this.setState({ mode: "normal", loading: false });
				this.menu_backup_v2 = null;
			} catch (e) {
				UI.notification.error((e as any)?.message ?? 'Failed to save prices');
				this.setState({ loading: false });
			}
			return;
		}

		const backup = cloneDeep(r);
		if (this.menu_backup) backup.menus = this.menu_backup;

		await this.saveRestaurantSilent({
			backup: backup,
			update: { $set: { menus: r.menus } },
			successMsg,
			before: () => this.setState({ loading: true }),
			onSuccess: () => {
				this.setState({ mode: "normal", loading: false });
				this.menu_backup = null;
			},
			onFail: () => this.setState({ loading: false }),
			onError: () => this.setState({ loading: false }),
		});
	};

	onDragStart = () => { };
	onDragUpdate = () => { };
	onDragEnd = (result: DropResult) => {
		const { destination, source, type } = result;
		if (!destination) return;
		const store = this.injected.store;
		const r = { ...store.restaurant! };

		if (store.isNewMenuSchema && r.menus_v2?.length) {
			const currentMenus = store.restaurant!.menus_v2!;
			if (type === "MENU") {
				if (destination.index !== source.index && source.index >= 0 && destination.index >= 0 && source.index < currentMenus.length && destination.index < currentMenus.length) {
					const next = arrayMove([...currentMenus], source.index, destination.index);
					store.updateRestaurant({ menus_v2: next });
				}
				return;
			}
			const menus = cloneDeep(r.menus_v2) as T.Schema.Restaurant.Menu.RestaurantMenuV2[];
			if (type === "CATEGORY") {
				const menuId = source.droppableId;
				const menuIndex = menus.findIndex((m: any) => m.id === menuId);
				if (menuIndex === -1) return;
				const menu = menus[menuIndex];
				if (destination.droppableId !== source.droppableId) {
					const destMenuId = destination.droppableId;
					const destMenuIndex = menus.findIndex((m: any) => m.id === destMenuId);
					if (destMenuIndex === -1) return;
					const cat = cloneDeep(menu.categories[source.index]) as any;
					cat.menu_id = destMenuId;
					const catItems = (menu.items || []).filter((i: any) => i.category_id === cat.id);
					menu.categories.splice(source.index, 1);
					menus[menuIndex] = { ...menu, items: (menu.items || []).filter((i: any) => i.category_id !== cat.id) };
					const destMenu = menus[destMenuIndex];
					catItems.forEach((it: any) => { it.menu_id = destMenuId; it.category_id = cat.id; });
					destMenu.categories.splice(destination.index, 0, cat);
					destMenu.items = [...(destMenu.items || []), ...catItems];
					menus[destMenuIndex] = destMenu;
				} else if (destination.index !== source.index) {
					menu.categories = arrayMove(menu.categories, source.index, destination.index);
					menu.categories.forEach((c: any, i: number) => { c.sort_order = i; });
					menus[menuIndex] = menu;
				}
				menus.forEach((m, i) => { (m as any).sort_order = i; });
				store.updateRestaurant({ menus_v2: menus });
			} else if (type === "DISH") {
				const categoryId = source.droppableId;
				let menuIndex = -1;
				let categoryIndex = -1;
				for (let mi = 0; mi < menus.length; mi++) {
					const ci = menus[mi].categories.findIndex((c: any) => c.id === categoryId);
					if (ci !== -1) { menuIndex = mi; categoryIndex = ci; break; }
				}
				if (menuIndex === -1) return;
				const menu = menus[menuIndex];
				const category = menu.categories[categoryIndex];
				const categoryItems = (menu.items || []).filter((i: any) => i.category_id === category.id);
				if (destination.droppableId !== source.droppableId) {
					const destCategoryId = destination.droppableId;
					let destMenuIndex = -1, destCategoryIndex = -1;
					for (let mi = 0; mi < menus.length; mi++) {
						const ci = menus[mi].categories.findIndex((c: any) => c.id === destCategoryId);
						if (ci !== -1) { destMenuIndex = mi; destCategoryIndex = ci; break; }
					}
					if (destMenuIndex === -1) return;
					const item = cloneDeep(categoryItems[source.index]) as any;
					item.category_id = destCategoryId;
					item.menu_id = menus[destMenuIndex].id;
					const rest = categoryItems.filter((_: any, i: number) => i !== source.index);
					menu.items = (menu.items || []).filter((i: any) => i.category_id !== category.id).concat(rest);
					menus[menuIndex] = menu;
					const destMenu = menus[destMenuIndex];
					const destCategoryItems = (destMenu.items || []).filter((i: any) => i.category_id === destCategoryId);
					destCategoryItems.splice(destination.index, 0, item);
					destMenu.items = (destMenu.items || []).filter((i: any) => i.category_id !== destCategoryId).concat(destCategoryItems);
					menus[destMenuIndex] = destMenu;
				} else if (destination.index !== source.index) {
					const reordered = arrayMove(categoryItems, source.index, destination.index);
					reordered.forEach((it: any, i: number) => { it.sort_order = i; });
					const otherItems = (menu.items || []).filter((i: any) => i.category_id !== category.id);
					menu.items = otherItems.concat(reordered);
					menus[menuIndex] = menu;
				}
				store.updateRestaurant({ menus_v2: menus });
			}
			return;
		}

		if (type === "MENU") {
			if (destination.index !== source.index) {
				r.menus = arrayMove(r.menus, source.index, destination.index);
				this.injected.store.setRestaurant(r);
			}
		} else if (type === "CATEGORY") {
			const menus = cloneDeep(r.menus);
			if (destination.droppableId !== source.droppableId) {
				const sourceMenu = source.droppableId;
				const destinationMenu = destination.droppableId;
				const sourceMenuIndex = menus.findIndex(
					(m) => m._id === sourceMenu
				);
				const destinationMenuIndex = menus.findIndex(
					(m) => m._id === destinationMenu
				);
				// CLT.ONE CATEGORY
				const item = cloneDeep(
					menus[sourceMenuIndex].categories[source.index]
				);
				item.menu_id = destinationMenu;
				for (let i = 0; i < item.dishes.length; i++) {
					item.dishes[i].menu_id = destinationMenu;
				}
				// REMOVE FROM OLD MENU
				menus[sourceMenuIndex].categories.splice(source.index, 1);
				// ADD TO NEW MENU
				menus[destinationMenuIndex].categories.splice(
					destination.index,
					0,
					item
				);
			} else if (destination.index !== source.index) {
				const menu_id = source.droppableId;
				const menu_index = menus.findIndex((m) => m._id === menu_id);
				menus[menu_index].categories = arrayMove(
					menus[menu_index].categories,
					source.index,
					destination.index
				);
			}
			r.menus = menus;
			this.injected.store.setRestaurant(r);
		} else if (type === "DISH") {
			const menus = cloneDeep(r.menus);
			if (destination.droppableId !== source.droppableId) {
				const sourceCategory = source.droppableId;
				const destinationCategory = destination.droppableId;

				const s = RestaurantUtils.menu.findCategoryById(
					r,
					sourceCategory
				);
				const d = RestaurantUtils.menu.findCategoryById(
					r,
					destinationCategory
				);

				if (!s || !d) return;

				// CLT.ONE CATEGORY
				const item = cloneDeep(
					menus[s.menuIndex].categories[s.categoryIndex].dishes[
					source.index
					]
				);
				item.menu_id = d.menu._id;
				item.category_id = d.category._id;

				// REMOVE FROM CATEGORY
				menus[s.menuIndex].categories[s.categoryIndex].dishes.splice(
					source.index,
					1
				);
				// ADD TO NEW CATEGORY
				menus[d.menuIndex].categories[d.categoryIndex].dishes.splice(
					destination.index,
					0,
					item
				);
			} else if (destination.index !== source.index) {
				const category_id = source.droppableId;
				const query = RestaurantUtils.menu.findCategoryById(
					r,
					category_id
				);
				if (!query) throw new Error("Category not found by id");
				const { menu, category, menuIndex, categoryIndex } = query;
				const dishes =
					menus[menuIndex].categories[categoryIndex].dishes;
				menus[menuIndex].categories[categoryIndex].dishes = arrayMove(
					dishes,
					source.index,
					destination.index
				);
			}
			r.menus = menus;
			this.injected.store.setRestaurant(r);
		}
	};

	float_button_pause = () => {
		const { selected_dishes } = this.state;
		const r = this.injected.store.restaurant!;
    const menus = r.menus_v2 || [];
		const allDishes = menus.flatMap(menu => menu.items);
		const selectedItems = allDishes.filter(item => selected_dishes.includes(item.id));
		this.setState({
			panel_pause: "item",
			currentMenuItems: selectedItems,
			bulkSelectedDishesSheetDismissed: true,
		});
	};

	float_button_resume = () => {
    const { selected_dishes } = this.state;
		if (selected_dishes.length > 0) {
			this.setState({ resumeModalOpen: true, bulkSelectedDishesSheetDismissed: true });
		}
	};

	handleCloseResumeModal = () => {
		this.setState({
			resumeModalOpen: false,
			selected_dishes: [],
			bulkSelectedDishesSheetDismissed: false,
		});
	};

	menu_list_floating = (
		selected_dishes: string[],
		selected_loading: boolean
	) => {
		return (
			<>
				<MenuListFloatingButtonWrapper>
					<MenuListFloatingContent>
						<MenuListFloatingTitle>
							<p className="font-semi-bold big">Actions</p>
							<p className="font-semi-bold small m-t-1">
								{selected_dishes.length} Selected
							</p>
						</MenuListFloatingTitle>
						<Button size="xs" onClick={this.float_button_cancel}>
							Cancel
						</Button>
						<Button size="xs" onClick={this.float_button_available}>
							Available
						</Button>
						<Button size="xs" onClick={this.float_button_no_stock}>
							No Stock
						</Button>
						<Button size="xs" onClick={this.float_button_hidden}>
							Hide
						</Button>
						<Button size="xs" onClick={this.showDeleteItemsModal}>
							Delete
						</Button>
						<Button size="xs" onClick={this.float_button_pause}>
							Pause Item
						</Button>
						<Button size="xs" onClick={this.float_button_resume}>
							Resume Item
						</Button>
						{selected_loading && (
							<div className="text-center p-1">
								<RotateLoader size={2} />
							</div>
						)}
					</MenuListFloatingContent>
				</MenuListFloatingButtonWrapper>
			</>
		);
	};

	saveCancelGroupButton(
		saveCallback: () => void,
		cancelCallback: () => void,
		loading: boolean,
		helperText?: string
	) {
		return (
			<div>
				<div className="grid-2 xs xs-gap m-t-10">
					<div className="col">
						<MenuListButton onClick={saveCallback}>
							{loading && <RotateLoader size={2} color="white" />}
							{!loading && "Save"}
						</MenuListButton>
					</div>
					<div className="col">
						<MenuListButton onClick={cancelCallback}>
							Cancel
						</MenuListButton>
					</div>
				</div>
				{helperText && (
					<div className="text-center m-t-3 font-semi-bold">
						<p>{helperText}</p>
					</div>
				)}
			</div>
		);
	}

	saveCancelGroupButtonV2(
		saveCallback: () => void,
		cancelCallback: () => void,
		loading: boolean,
		helperText?: string
	) {
		return (
			<EditPricesModeWrapper>
				<div className="grid-2 xs xs-gap edit-prices-mode-buttons">
					<div className="col">
						<ButtonV2 onClick={saveCallback}>
							{loading && <RotateLoader size={2} color="white" />}
							{!loading && "Save"}
						</ButtonV2>
					</div>
					<div className="col">
						<ButtonV2
							variant="default"
							onClick={cancelCallback}>
							Cancel
						</ButtonV2>
					</div>
				</div>
				{helperText && (
					<div className="text-center m-t-3 font-semi-bold">
						<p>{helperText}</p>
					</div>
				)}
			</EditPricesModeWrapper>
		);
	}

	openMenuMoreActions = (index: number, type: string) => {
		this.setState({
			targetMenuIndex: index,
			targetItem: type
		});
		this.injected.store.setActiveMobileModal('menu-more-actions');
	}
	openCategoryMoreActions = (index: number, menuIndex: number, type: string) => {
		this.setState({
			targetMenuIndex: menuIndex,
			targetCategoryIndex: index,
			targetItem: type
		});
		this.injected.store.setActiveMobileModal('category-more-actions');
	}
	openItemMoreActions = (index: number, categoryIndex: number, menuIndex: number, type: string) => {
		this.setState({
			targetMenuIndex: menuIndex,
			targetCategoryIndex: categoryIndex,
			targetIndex: index,
			targetItem: type
		});
		this.injected.store.setActiveMobileModal('item-more-actions');
	}

	closeMenuMoreActions = () => {
		this.setState({
			targetMenuIndex: -1,
			targetCategoryIndex: -1,
			targetIndex: -1,
			targetItem: 'menu'
		});
		this.injected.store.setActiveMobileModal('');
	}

	closeCategoryMoreActions = () => {
		this.setState({
			targetMenuIndex: -1,
			targetCategoryIndex: -1,
			targetIndex: -1,
			targetItem: 'category'
		});
		this.injected.store.setActiveMobileModal('');
	}

	closeItemMoreActions = () => {
		this.setState({
			targetMenuIndex: -1,
			targetCategoryIndex: -1,
			targetIndex: -1,
			targetItem: 'item'
		});
		this.injected.store.setActiveMobileModal('');
	}

	modal_menu_more_actions = () => {
		const { store } = this.injected;
		const r = store.restaurant!;
		const { activeMobileModal, setActiveMobileModal } = store;
		let menu;
		if(store.isNewMenuSchema) {
			menu = (r.menus_v2 || [])[this.state.targetMenuIndex];
		} else {
			menu = r.menus[this.state.targetMenuIndex];
		}
		if(!menu) return null;
		let title = menu?.name || 'Menu';
		return (
			<MenuMoreAction
				show={activeMobileModal === 'menu-more-actions'}
				title={title || ''	}
				onHide={this.closeMenuMoreActions}
				onSave={() => {
					setActiveMobileModal('')
					UI.notification.success('Menu updated');
				}}>
				<MenuActionContainer>
					<MenuActionItem onClick={() => {
						store.setActiveMobileMenu('edit-menu', 'menus', {panel: 'menu', index: this.state.targetMenuIndex});
						this.closeMenuMoreActions();
					}}>
						<IconEdit /> Edit
					</MenuActionItem>
					<MenuActionItem onClick={() => {
						this.modal_remove_open("menu", [this.state.targetMenuIndex]);
						this.closeMenuMoreActions();
					}}>
						<IconDelete /> Delete
					</MenuActionItem>
					<MenuActionItem onClick={() => {
						this.modal_copy_open("menu", [this.state.targetMenuIndex]);
						this.closeMenuMoreActions();
					}}>
						<IconCopyAlt /> Duplicate
					</MenuActionItem>
				</MenuActionContainer>
			</MenuMoreAction>
		)
	}
	modal_category_more_actions = () => {
		const { store } = this.injected;
		const r = store.restaurant!;
		const { activeMobileModal, setActiveMobileModal } = store;
		let category;
		if(store.isNewMenuSchema) {
			category = (r.menus_v2 || [])[this.state.targetMenuIndex]?.categories[this.state.targetCategoryIndex];
		} else {
			category = r.menus[this.state.targetMenuIndex]?.categories[this.state.targetCategoryIndex];
		}
		if(!category) return null;
		let title = category?.name || 'Category';
		return (
			<MenuMoreAction
				show={activeMobileModal === 'category-more-actions'}
				title={title}
				onHide={this.closeMenuMoreActions}
				onSave={() => {
					setActiveMobileModal('')
					UI.notification.success('Category updated');
				}}>
				<MenuActionContainer>
					<MenuActionItem onClick={() => {
						store.setActiveMobileMenu('edit-category', 'menus', {panel: 'category', menuIndex: this.state.targetMenuIndex, categoryIndex: this.state.targetCategoryIndex});
						this.closeCategoryMoreActions();
					}}>
						<IconEdit /> Edit
					</MenuActionItem>
					<MenuActionItem onClick={() => {
						this.modal_remove_open("category", [this.state.targetMenuIndex, this.state.targetCategoryIndex]);
						this.closeCategoryMoreActions();
					}}>
						<IconDelete /> Delete
					</MenuActionItem>
					<MenuActionItem onClick={() => {
						this.modal_copy_open("category", [this.state.targetMenuIndex, this.state.targetCategoryIndex]);
						this.closeCategoryMoreActions();
					}}>
						<IconCopyAlt /> Duplicate
					</MenuActionItem>
				</MenuActionContainer>
			</MenuMoreAction>
		)
	}
	modal_item_more_actions = () => {
		const { store } = this.injected;
		const r = store.restaurant!;
		const { activeMobileModal, setActiveMobileModal } = store;
		let item;
		if(store.isNewMenuSchema) {
			item = (r.menus_v2 || [])[this.state.targetMenuIndex]?.items[this.state.targetIndex] as T.Schema.Restaurant.Menu.RestaurantItem;
		} else {
			item = r.menus[this.state.targetMenuIndex]?.categories[this.state.targetCategoryIndex]?.dishes[this.state.targetIndex];
		}
		if(!item) return null;
		let title = item?.name || 'Item';
		return (
			<MenuMoreAction
				show={activeMobileModal === 'item-more-actions'}
				title={title}
				onHide={this.closeItemMoreActions}
				onSave={() => {
					setActiveMobileModal('')
					UI.notification.success('Item updated');
				}}>
				<MenuActionContainer>
					<MenuActionItem onClick={() => {
						this.setOnPause("item", [
							this.state.targetMenuIndex,
							this.state.targetCategoryIndex,
							this.state.targetIndex,
							//@ts-ignore
						], item?.id || item?._id, item, [item])
						this.closeItemMoreActions();
					}}>
						<IoIosPause /> Pause
					</MenuActionItem>
					<MenuActionItem onClick={() => {
						store.setActiveMobileMenu('edit-item', 'menus', {panel: 'item', menuIndex: this.state.targetMenuIndex, categoryIndex: this.state.targetCategoryIndex, dishIndex: this.state.targetIndex});
						this.closeItemMoreActions();
					}}>
						<IconEdit /> Edit
					</MenuActionItem>
					<MenuActionItem onClick={() => {
						this.modal_remove_open("item", [this.state.targetMenuIndex, this.state.targetCategoryIndex, this.state.targetIndex]);
						this.closeItemMoreActions();
					}}>
						<IconDelete /> Delete
					</MenuActionItem>
					<MenuActionItem onClick={() => {
						this.modal_copy_open("item", [this.state.targetMenuIndex, this.state.targetCategoryIndex, this.state.targetIndex]);
						this.closeItemMoreActions();
					}}>
						<IconCopyAlt /> Duplicate
					</MenuActionItem>
				</MenuActionContainer>
			</MenuMoreAction>
		)
	}

	render() {
		const {
			selected_dishes,
			selected_loading,
			activeMenuColorModal,
			activeMenuColorTitle,
			activeMenuColorData,
			activeMenuVisibilityModal,
			activeMenuPrevisibilityModal,
			targetItem,
			menuColorBulkItemIds,
			resumeModalOpen,
			activeDeleteItemModal,
			remove_loading,
			mode,
			bulkSelectedDishesSheetDismissed,
		} = this.state;

		const { store } = this.injected;
		const { activeMobileModal, setActiveMobileModal, openMenuListItemActive } = store;
		const r = store.restaurant;

		const menuEditCollaboration =
			store.organisation?.dashboard === 'v2.1' && store.isNewMenuSchema;
		const menuEditLock = store.ably.menuEditLock;
		const menuEditMyConnectionId = store.notifications.ablyRestaurant?.connection?.id;
		const menuEditBlocked =
			menuEditCollaboration &&
			store.ably.connected_once &&
			!!menuEditLock &&
			!!menuEditMyConnectionId &&
			menuEditLock.connectionId !== menuEditMyConnectionId;
		const menusV2 = (r?.menus_v2 ?? []) as any[];
		const derivedOverrideTarget: OverrideTargetEntity | null = (() => {
			if (!openMenuListItemActive || !store.isNewMenuSchema || !menusV2.length) return null;
			const parts = openMenuListItemActive.split('_');
			if (parts.length === 1) {
				const menu = menusV2.find((m: any) => m.id === parts[0]);
				return menu ? { type: 'menu', name: menu.name } : null;
			}
			if (parts.length === 2) {
				const menu = menusV2.find((m: any) => m.id === parts[0]);
				const category = menu?.categories?.find((c: any) => c.id === parts[1]);
				return category ? { type: 'category', name: category.name } : null;
			}
			if (parts.length === 3) {
				const menu = menusV2.find((m: any) => m.id === parts[0]);
				const item = menu?.items?.find((i: any) => i.id === parts[2]);
				return item ? { type: 'item', name: item.name } : null;
			}
			return null;
		})();
		const overrideTargetEntity = this.state.preOverrideContext?.targetEntity ?? derivedOverrideTarget;
		const overrideChangesSummary = this.state.preOverrideContext?.changesSummary ?? null;
		const overrideEditKind = this.state.preOverrideContext?.editKind ?? 'visibility';
		const overrideAffectedEntities = this.state.preOverrideContext?.affectedEntities ?? null;
		const overrideSource = (() => {
			if (this.state.preOverrideContext?.overrideSource) return this.state.preOverrideContext.overrideSource;
			if (!openMenuListItemActive || !store.isNewMenuSchema || !menusV2.length) return undefined;
			const parts = openMenuListItemActive.split('_');
			return {
				menuId: parts[0],
				categoryId: parts.length >= 2 ? parts[1] : undefined,
				itemId: parts.length >= 3 ? parts[2] : undefined,
			};
		})();

		return (
			<>
				<ResumeModal
					isOpen={resumeModalOpen}
					handleClose={this.handleCloseResumeModal}
					menuItemIds={selected_dishes}
				/>
				{activeDeleteItemModal && selected_dishes.length > 0 && (
					<div>
						<Modal
							width="sm"
							close={() => this.setState({ activeDeleteItemModal: false })}
							closeButton={false}
							active={activeDeleteItemModal}
						>
							<ModalContent className="flex-l-r-center">
								<h4 className="">
									{selected_dishes.length > 1
										? `Delete ${selected_dishes.length} items`
										: "Delete Item"}
								</h4>
							</ModalContent>
							<ModalContent className="flex-right">
								<Button
									type="button"
									className="m-r-2 width100 max100px"
									onClick={() => this.setState({ activeDeleteItemModal: false })}
								>
									Cancel
								</Button>
								<Button
									type="button"
									className="width100 max100px"
									color="primary"
									onClick={this.float_button_delete}
								>
									{remove_loading && <RotateLoader size={2} color="white" />}
									{!remove_loading && "Delete"}
								</Button>
							</ModalContent>
						</Modal>
					</div>
				)}
				{store.isNewMenuSchema &&
					mode === "normal" &&
					selected_dishes.length > 0 &&
					!bulkSelectedDishesSheetDismissed && (
						<MenuMoreAction
							show={true}
							title={`${selected_dishes.length} selected`}
							onHide={this.closeBulkSelectedDishesSheet}
							onSave={() => {}}
						>
							<MenuActionContainer>
								<MenuActionItem onClick={this.bulkSelectAllInCategoryOfFirst}>
									Select All
								</MenuActionItem>
								<MenuActionItem onClick={this.openBulkItemColorFromSheet}>
									Item Color
								</MenuActionItem>
								<MenuActionItem onClick={this.openBulkPrinterAssignFromSheet}>
									Assign Printer
								</MenuActionItem>
								<MenuActionItem onClick={this.float_button_cancel}>Cancel</MenuActionItem>
								<MenuActionItem onClick={this.float_button_available}>Available</MenuActionItem>
								<MenuActionItem onClick={this.float_button_no_stock}>No Stock</MenuActionItem>
								<MenuActionItem onClick={this.float_button_hidden}>Hide</MenuActionItem>
								<MenuActionItem onClick={this.showDeleteItemsModal}>Delete</MenuActionItem>
								<MenuActionItem onClick={this.float_button_pause}>
									<IoIosPause /> Pause Item
								</MenuActionItem>
								<MenuActionItem onClick={this.float_button_resume}>Resume Item</MenuActionItem>
								{selected_loading && (
									<div className="text-center p-1">
										<RotateLoader size={2} />
									</div>
								)}
							</MenuActionContainer>
						</MenuMoreAction>
					)}
				<div className="relative" style={{ width: '100%'}}>
					<div
						style={{
							opacity: menuEditBlocked ? 0.55 : 1,
							transition: 'opacity 0.15s ease',
						}}>
						{selected_dishes.length > 0 && !store.isNewMenuSchema &&
							this.menu_list_floating(selected_dishes, selected_loading)}

						<DragDropContext
							onDragStart={this.onDragStart}
							onDragUpdate={this.onDragUpdate}
							onDragEnd={this.onDragEnd}
						>
							{store.isNewMenuSchema && this.list_menu_v2()}
							{!store.isNewMenuSchema && this.list_menu()}
							{this.modal_copy()}
							{this.modal_remove()}
							{this.panel_menu()}
							{this.panel_category()}
							{this.panel_dish()}
						</DragDropContext>
					</div>
					{menuEditBlocked && (
						<div
							role="presentation"
							style={{
								position: 'absolute',
								inset: 0,
								zIndex: 40,
								cursor: 'not-allowed',
							}}
						/>
					)}
				</div>
				{this.sidebar_panel_dish()}
				{this.modal_menu_more_actions()}
				{this.modal_category_more_actions()}
				{this.modal_item_more_actions()}
				<MenuColor
					show={activeMenuColorModal}
					title={activeMenuColorTitle}
					item={targetItem}
					hideItemImage={
						targetItem === 'item' &&
						!!menuColorBulkItemIds &&
						menuColorBulkItemIds.length > 1
					}
					onHide={() =>
						this.setState((s) => ({
							activeMenuColorModal: !s.activeMenuColorModal,
							menuColorBulkItemIds: null,
							bulkSelectedDishesSheetDismissed:
								s.selected_dishes.length > 0 ? false : s.bulkSelectedDishesSheetDismissed,
						}))
					}
					onSave={(color, media_url) => {
						const bulkIds = this.state.menuColorBulkItemIds;
						this.setState(
							{
								activeMenuColorData: {
									...activeMenuColorData,
									color: color,
									media_url,
								},
								activeMenuColorModal: !activeMenuColorModal,
								menuColorBulkItemIds: null,
							},
							async () => {
						const r = store.restaurant!;
						const copyMenus = cloneDeep(r.menus_v2 || []);
						const { targetMenuIndex, targetCategoryIndex, targetIndex, targetItem } = this.state;

						if (targetItem === 'item') {
							if (bulkIds && bulkIds.length > 0) {
                const itemUpdates = [];
								for (const itemId of bulkIds) {
									const found = findItemInMenusV2(copyMenus, itemId);
									if (!found) continue;
									const { menuIndex, categoryId, item, globalIdx } = found;
									const menu = copyMenus[menuIndex];
									const prevMedia = item.media_url || '';
									const nextMedia = bulkIds.length > 1 ? prevMedia : media_url || '';
                  itemUpdates.push({
                    id: item.id,
                    menu_id: menu.id,
                    category_id: categoryId,
                    color: color,
                    media_url: nextMedia,
                  })
									const nextItems = [...menu.items];
									nextItems[globalIdx] = {
										...nextItems[globalIdx],
										color,
										media_url: nextMedia,
									};
									copyMenus[menuIndex] = { ...menu, items: nextItems };
								}
                await store.api.menu_partial_update_batch_items({
                  restaurant_id: r._id,
                  data: {
                    items: itemUpdates,
                  }
                })
								await store.updateRestaurant({ menus_v2: copyMenus });
								UI.notification.success(
									itemUpdates.length === 1 ? 'Item updated' : `${itemUpdates.length} items updated`
								);
								if (bulkIds.length > 1) {
									this.setState({ bulkSelectedDishesSheetDismissed: false });
								}
								return;
							}
							const menu = copyMenus[targetMenuIndex];
							const category = menu.categories[targetCategoryIndex];
							const itemsInCat = menu.items
								.map((it: any, globalIdx: number) => ({ it, globalIdx }))
								.filter(x => x.it.category_id === category.id);
							const { it: targetIt, globalIdx } = itemsInCat[targetIndex] ?? {};
							if (!targetIt || globalIdx === undefined) {
								UI.notification.error('Could not update item');
								return;
							}
							await store.api.menu_partial_update_item({
								restaurant_id: r._id,
								menu_id: menu.id,
								category_id: category.id,
								item_id: targetIt.id,
								data: { color, media_url: media_url || '' },
							});
							const nextItems = [...menu.items];
							nextItems[globalIdx] = { ...nextItems[globalIdx], color, media_url: media_url || '' };
							copyMenus[targetMenuIndex] = { ...menu, items: nextItems };
							await store.updateRestaurant({ menus_v2: copyMenus });
							UI.notification.success('Item updated');
							return;
						}

						const menuIdx = targetItem === 'menu' ? targetIndex : targetMenuIndex;
						const menu = copyMenus[menuIdx];
						const preMergeAvailById = new Map<string, any>();
						(menu.availabilities || []).forEach((a: any) => preMergeAvailById.set(a.id, cloneDeep(a)));

						if (targetItem === 'category') {
							const cat = menu.categories[targetIndex];
							await store.api.menu_partial_update_category({
								restaurant_id: r._id,
								menu_id: menu.id,
								category_id: cat.id,
								data: { color, media_url: media_url || '' },
							});
							const copyCategories = [...menu.categories];
							copyCategories[targetIndex] = {
								...copyCategories[targetIndex],
								color,
								media_url: media_url || '',
							};
							copyMenus[menuIdx] = { ...menu, categories: copyCategories };
							UI.notification.success('Category updated');
						} else {
							await store.api.menu_partial_update_menu({
								restaurant_id: r._id,
								menu_id: menu.id,
								data: { color, media_url: media_url || '' },
							});
							copyMenus[menuIdx] = { ...menu, color, media_url: media_url || '' };
							UI.notification.success('Menu updated');
						}

						const m = copyMenus[menuIdx];
						const mergedAvailSlot = getAvailFromMenuById(m, m.availability_id) || {};
						const { affectedRows, changesSummary } = analyzeDescendantsOverride({
							menu: m,
							targetType: targetItem === 'menu' ? 'menu' : 'category',
							categoryId: targetItem === 'category' ? m.categories[targetIndex]?.id : undefined,
							editKind: 'color',
							preMergeAvailById,
							mergedParentAvailability: mergedAvailSlot,
							mergedParentAvailabilityId: m.availability_id || '',
							newColor: color,
							newMediaUrl: media_url || '',
						});

						await store.updateRestaurant({ menus_v2: copyMenus });

						if (affectedRows.length === 0) return;

						const pending: MenuPendingOverride = {
							kind: 'color',
							targetEntityType: targetItem === 'menu' ? 'menu' : 'category',
							menuIndex: menuIdx,
							menuId: m.id,
							categoryId: targetItem === 'category' ? m.categories[targetIndex]?.id : undefined,
							parentAvailabilityId: m.availability_id || '',
							parentMergedAvailability: mergedAvailSlot,
							newColor: color,
							newMediaUrl: media_url || '',
						};

						const targetEntity: OverrideTargetEntity =
							targetItem === 'menu'
								? { type: 'menu', name: m.name, categoryCount: m.categories?.length, itemCount: m.items?.length }
								: {
										type: 'category',
										name: m.categories[targetIndex]?.name ?? '',
										itemCount: m.items?.filter((i: any) => i.category_id === m.categories[targetIndex]?.id).length,
									};

						this.setState({
							preOverrideContext: {
								targetEntity,
								overrideSource: {
									menuId: m.id,
									categoryId: targetItem === 'category' ? m.categories[targetIndex]?.id : undefined,
								},
								changesSummary,
								editKind: 'color',
								affectedEntities: affectedRows,
								pendingOverride: pending,
							},
						});
						setActiveMobileModal('desktop-menu-preoverride');
							}
						);
					}}
					value={activeMenuColorData}
				/>

				<MenuVisibility
					show={activeMenuVisibilityModal}
					title={overrideTargetEntity?.name || ''}
					onHide={() => this.setState({
						activeMenuVisibilityModal: !activeMenuVisibilityModal,
						activeMenuPrevisibilityModal: !activeMenuPrevisibilityModal
					})}
					onSave={async (conditions) => {
						const r = store.restaurant!;
						const baseCtx = this.state.preOverrideContext;
						if (!overrideSource?.menuId || !baseCtx?.targetEntity) return;

						const copyMenus = cloneDeep(r.menus_v2 || []);
						const targetMenuIndex = copyMenus.findIndex((menu: any) => menu.id === overrideSource.menuId);
						if (targetMenuIndex < 0) return;

						const targetMenu = copyMenus[targetMenuIndex];
						const preMergeAvailById = new Map<string, any>();
						(targetMenu.availabilities || []).forEach((a: any) => preMergeAvailById.set(a.id, cloneDeep(a)));

						const targetCategoryIndex = targetMenu.categories.findIndex(
							(category: any) => category.id === overrideSource.categoryId
						);
						const targetCategory =
							targetCategoryIndex >= 0 ? targetMenu.categories[targetCategoryIndex] : null;
						const targetItemIndex = targetMenu.items.findIndex((item: any) => item.id === overrideSource.itemId);
						const targetItemRow = targetItemIndex >= 0 ? targetMenu.items[targetItemIndex] : null;

						const targetItemAvailabilityIndex =
							targetItemRow && targetItemRow.availability_id
								? targetMenu.availabilities.findIndex((a: any) => a.id === targetItemRow.availability_id)
								: -1;
						const targetItemAvailability =
							targetItemAvailabilityIndex >= 0
								? targetMenu.availabilities[targetItemAvailabilityIndex]
								: null;

						const targetCategoryAvailabilityIndex =
							targetCategory && targetCategory.availability_id
								? targetMenu.availabilities.findIndex((a: any) => a.id === targetCategory.availability_id)
								: -1;
						const targetCategoryAvailability =
							targetCategoryAvailabilityIndex >= 0
								? targetMenu.availabilities[targetCategoryAvailabilityIndex]
								: null;

						const targetMenuAvailabilityIndex = targetMenu.availabilities.findIndex(
							(a: any) => a.id === targetMenu.availability_id
						);
						const targetMenuAvailability = targetMenu.availabilities[targetMenuAvailabilityIndex];

						let mergedParentAvailability: any;
						let mergedParentAvailabilityId: string;

						if (overrideTargetEntity?.type === 'item') {
							if (
								!targetCategory ||
								!targetItemRow ||
								targetItemAvailabilityIndex < 0 ||
								!targetItemAvailability
							) {
								UI.notification.error('Could not update item visibility');
								return;
							}
							await store.api.menu_partial_update_item({
								restaurant_id: r._id,
								menu_id: targetMenu.id,
								category_id: targetCategory.id,
								item_id: targetItemRow.id,
								data: {
									availability: { ...targetItemAvailability, ...conditions },
									availability_id: targetItemRow.availability_id,
								},
							});
							//@ts-ignore MenuVisibility conditions shape vs Availability
							copyMenus[targetMenuIndex].availabilities[targetItemAvailabilityIndex] = {
								...targetItemAvailability,
								...conditions,
							};
							UI.notification.success('Item updated');
							await store.updateRestaurant({ menus_v2: copyMenus });
							this.setState({
								activeMenuVisibilityModal: false,
								activeMenuPrevisibilityModal: false,
							});
							return;
						}

						if (overrideTargetEntity?.type === 'category') {
							if (
								!targetCategory ||
								targetCategoryAvailabilityIndex < 0 ||
								!targetCategoryAvailability
							) {
								UI.notification.error('Could not update category visibility');
								return;
							}
							await store.api.menu_partial_update_category({
								restaurant_id: r._id,
								menu_id: targetMenu.id,
								category_id: targetCategory.id,
								data: {
									availability: { ...targetCategoryAvailability, ...conditions },
									availability_id: targetCategory.availability_id,
								},
							});
							//@ts-ignore MenuVisibility conditions shape vs Availability
							copyMenus[targetMenuIndex].availabilities[targetCategoryAvailabilityIndex] = {
								...targetCategoryAvailability,
								...conditions,
							};
							mergedParentAvailability =
								copyMenus[targetMenuIndex].availabilities[targetCategoryAvailabilityIndex];
							mergedParentAvailabilityId = targetCategory.availability_id!;
							UI.notification.success('Category updated');
						} else {
							if (targetMenuAvailabilityIndex < 0 || !targetMenuAvailability) {
								UI.notification.error('Could not update menu visibility');
								return;
							}
							await store.api.menu_partial_update_menu({
								restaurant_id: r._id,
								menu_id: targetMenu.id,
								data: {
									availability: { ...targetMenuAvailability, ...conditions },
									availability_id: targetMenu.availability_id,
								},
							});
							//@ts-ignore MenuVisibility conditions shape vs Availability
							copyMenus[targetMenuIndex].availabilities[targetMenuAvailabilityIndex] = {
								...targetMenuAvailability,
								...conditions,
							};
							mergedParentAvailability =
								copyMenus[targetMenuIndex].availabilities[targetMenuAvailabilityIndex];
							mergedParentAvailabilityId = targetMenu.availability_id!;
							UI.notification.success('Menu updated');
						}

						const menuForAnalysis = copyMenus[targetMenuIndex];
						const { affectedRows, changesSummary } = analyzeDescendantsOverride({
							menu: menuForAnalysis,
							targetType: overrideTargetEntity!.type as 'menu' | 'category',
							categoryId: overrideSource.categoryId,
							editKind: 'visibility',
							preMergeAvailById,
							mergedParentAvailability,
							mergedParentAvailabilityId,
						});

						await store.updateRestaurant({ menus_v2: copyMenus });

						this.setState({
							activeMenuVisibilityModal: false,
							activeMenuPrevisibilityModal: false,
						});

						if (affectedRows.length === 0) return;

						const pending: MenuPendingOverride = {
							kind: 'visibility',
							targetEntityType: overrideTargetEntity!.type as 'menu' | 'category',
							menuIndex: targetMenuIndex,
							menuId: targetMenu.id,
							categoryId: overrideSource.categoryId,
							parentAvailabilityId: mergedParentAvailabilityId,
							parentMergedAvailability: mergedParentAvailability,
						};

						this.setState({
							preOverrideContext: {
								...baseCtx,
								changesSummary,
								editKind: 'visibility',
								affectedEntities: affectedRows,
								pendingOverride: pending,
							},
						});
						setActiveMobileModal('desktop-menu-preoverride');
					}}
					initialConditions={overrideTargetEntity?.conditions || null}
				/>
				<MenuPreVisibility
					show={activeMenuPrevisibilityModal}
					title={overrideTargetEntity?.name || ''}
					onHide={() => this.setState({
						activeMenuPrevisibilityModal: !activeMenuPrevisibilityModal})}
					onSave={(color) => this.setState({
						activeMenuPrevisibilityModal: !activeMenuPrevisibilityModal
					}) }
					onShowSettings={() => {
						this.setState({
							activeMenuVisibilityModal:!activeMenuVisibilityModal,
							activeMenuPrevisibilityModal: !activeMenuPrevisibilityModal
						})
					}}
					conditions={overrideTargetEntity?.conditions || null}
					type={overrideTargetEntity?.type || 'menu'}
					categoryCount={overrideTargetEntity?.categoryCount || 0}
					itemCount={overrideTargetEntity?.itemCount || 0}
				/>

				<MenuFilterMenu
					show={activeMobileModal === 'desktop-filter-menu'}
					title={""}
					onHide={() => setActiveMobileModal('')}
					onSave={() => setActiveMobileModal('')}
				/>

				<MenuPrinterSettings
						show={activeMobileModal === 'desktop-printer-settings'}
						title={"Printer Setup"}
						onHide={() => setActiveMobileModal('')}
						onClickPrinter={(printer) => {
							this.setState({ selectedPrinterForEligible: { name: printer.name, _id: printer._id } });
							setActiveMobileModal('desktop-printer-eligible-items');
						}}
				/>
				<MenuPrinterEligibleItems
						show={activeMobileModal === 'desktop-printer-eligible-items'}
						title={this.state.selectedPrinterForEligible?.name ?? 'Eligible Items'}
						printerName={this.state.selectedPrinterForEligible?.name}
						onHide={() => { this.setState({ selectedPrinterForEligible: null }); setActiveMobileModal('desktop-printer-settings'); }}
						onSave={(selectedIds) => {
							UI.notification.success('Printer eligible items saved');
							this.setState({ selectedPrinterForEligible: null });
							setActiveMobileModal('desktop-printer-settings');
						}}
				/>

				<MenuPrinterAssignItems
						show={activeMobileModal === 'desktop-printer-assign-items'}
						title={
							this.state.printerAssignBulkItemIds && this.state.printerAssignBulkItemIds.length > 1
								? `Assign printer (${this.state.printerAssignBulkItemIds.length} items)`
								: 'Assign printer for this item'
						}
						selectedPrinterValues={(() => {
							const t = this.state.printerAssignTarget;
							if (!t || !store.isNewMenuSchema) return undefined;
							const r = store.restaurant!;
							const menus = r.menus_v2 || [];
							const menu = menus[t.menuIndex];
							if (!menu?.items) return undefined;
							const item = menu.items.find((i: any) => i.id === t.itemId);
							return (item as any)?.integrations?.pushpos?.printers;
						})()}
						onHide={() => {
							this.setState((s) => ({
								printerAssignTarget: null,
								printerAssignBulkItemIds: null,
								bulkSelectedDishesSheetDismissed:
									s.selected_dishes.length > 0 ? false : s.bulkSelectedDishesSheetDismissed,
							}));
							setActiveMobileModal('');
						}}
						onSave={async (selectedPrinterValues) => {
							const t = this.state.printerAssignTarget;
							const bulkIds = this.state.printerAssignBulkItemIds;
							if (!t || !store.isNewMenuSchema) {
								setActiveMobileModal('');
								return;
							}
							const r = store.restaurant!;
							const refs = bulkIds?.length
								? this.getSelectedItemRefsV2().filter((ref) => bulkIds.includes(ref.id))
								: [{ menu_id: t.menuId, category_id: t.categoryId, id: t.itemId }];
							if (refs.length === 0) {
								this.setState({ printerAssignTarget: null, printerAssignBulkItemIds: null });
								setActiveMobileModal('');
								return;
							}
							try {
                await store.api.menu_partial_update_batch_items({
                  restaurant_id: r._id,
                  data: {
                    items: refs.map((item: any) => ({ ...item, integrations: { pushpos: { printers: selectedPrinterValues } }}) ),
                  }
                })
								UI.notification.success(
									refs.length > 1 ? `Printers updated for ${refs.length} items` : 'Printers updated'
								);
								const menus = cloneDeep(r.menus_v2 || []);
								for (const { menu_id, id } of refs) {
									const menu = menus.find((m: any) => m.id === menu_id);
									const item = menu?.items?.find((i: any) => i.id === id);
									if (item) {
										(item as any).integrations = (item as any).integrations || {};
										(item as any).integrations.pushpos = {
											...(item as any).integrations?.pushpos,
											printers: selectedPrinterValues,
										};
									}
								}
								store.updateRestaurant({ menus_v2: menus });
							} catch (e) {
								UI.notification.error((e as any)?.message ?? 'Failed to update');
							}
							this.setState((s) => ({
								printerAssignTarget: null,
								printerAssignBulkItemIds: null,
								bulkSelectedDishesSheetDismissed:
									s.selected_dishes.length > 0 ? false : s.bulkSelectedDishesSheetDismissed,
							}));
							setActiveMobileModal('');
						}}
				/>

				<MenuPreOverride
					show={activeMobileModal === 'desktop-menu-preoverride'}
					title="Override warning"
					targetEntity={overrideTargetEntity}
					overrideSource={overrideSource}
					changesSummary={overrideChangesSummary}
					editKind={overrideEditKind}
					affectedEntities={overrideAffectedEntities}
					onHide={() => { this.setState({ preOverrideContext: null }); setActiveMobileModal(''); }}
					onKeepCurrent={() => { this.setState({ preOverrideContext: null }); setActiveMobileModal(''); }}
					onConfirm={async () => {
						if (this.state.preOverrideContext?.pendingOverride) {
							await this.applyPendingMenuOverride();
						} else {
							UI.notification.success('Overrides applied');
						}
						this.setState({ preOverrideContext: null });
						setActiveMobileModal('');
					}}
				/>

				<EditingStatusAlertModal
					active={activeMobileModal === 'desktop-editing-status'}>
					<EditingStatusAlertModalContent>
						<EditingStatusAlertModalHeader>
							<EditingStatusAlertModalHeaderText>
							Someone is currently editing this menu
							</EditingStatusAlertModalHeaderText>
							<EditingStatusIconWrapper
								onClick={() => setActiveMobileModal('')}>
								<IconEditingClose />
							</EditingStatusIconWrapper>
						</EditingStatusAlertModalHeader>
						<EditingStatusAlertModalBody>
							{menuEditLock?.userName ? (
								<p style={{ marginBottom: 12, color: '#4B4F5E', fontSize: 14 }}>
									{menuEditLock.userName} has control. Request control to take over editing.
								</p>
							) : null}
							<ButtonV2
								className="flex-auto"
								onClick={() => {
									store.notifications.menuEditingRequestTakeover();
									setActiveMobileModal('');
								}}>
								Request Control <IconArrowForwardWhite/>
							</ButtonV2>
							<ButtonV2
								variant='default'
								onClick={() => setActiveMobileModal('')}>
								Cancel
							</ButtonV2>
						</EditingStatusAlertModalBody>
					</EditingStatusAlertModalContent>
				</EditingStatusAlertModal>
			</>
		);
	}
}
